const language = {
    // 简体中文
    'zh': {
        common1: '没有查找到数据哟~',
        common2: '取消',
        common3: '关闭',
        common4: '请输入',
        common5: '确定',
        common6: '用户中心',
        common7: '请选择',
        common8: '请先完善表单内容哦~',
        common9: '开始时间',
        common10: '结束时间',
        common11: '查询',
        common12: '重置',
        common13: '是否确定删除',
        common14: '删除',
        common15: '没有查询到该订单信息哟',
        tools1: '文本已复制到剪贴板',
        tools2: '复制到剪贴板失败',
        Home1: '用户ID',
        Home2: '最后一次登录时间',   
        Home3: '最后一次登录IP', 
        Home4: '账户余额', 
        Home5: '立即充值', 
        Home6: '余额明细', 
        Home7: '优惠卷', 
        Home8: '查看', 
        Home9: '工单处理', 
        Home10: '客户经理', 
        Home11: '售后客服', 
        Home12: '渠道经理', 
        Home13: '帮助中心', 
        Home14: '专属客服', 
        Home15: '在线咨询', 
        Home16: '提交工单',
        Home17: '近期数据',
        Home18: '有效服务器',
        Home19: '有效域名', 
        Home20: '7天内到期物理机', 
        Home21: '7天内到期VPS', 
        Home22: '7天内到期云服务器', 
        Home23: '公告通知', 
        Home24: '通知',
        Home25: '产品服务',
        Home26: '域名',
        Home27: '物理机',
        Home28: 'SSL证书',
        Home29: '云服务器',
        Home30: '帮助文档',
        Home31: '文档',
        Home32: '暂无该联系方式',
        LayOut1: '控制台',
        LayOut2: '用户中心',
        LayOut3: '域名管理',
        LayOut4: '域名列表',
        LayOut5: '域名模板',
        LayOut6: '物理机管理',
        LayOut7: '服务器列表',
        LayOut8: '云主机管理',
        LayOut9: '云主机列表',
        LayOut10: 'VPS管理',
        LayOut11: 'SSL管理',
        LayOut12: 'SSL列表',
        LayOut13: 'SSL模板',
        LayOut14: '账户管理',
        LayOut15: '账户信息',
        LayOut16: '登录日志',
        LayOut17: '通知设置',
        LayOut18: '订单管理',
        LayOut19: '物理机订单',
        LayOut20: '云主机订单',
        LayOut21: '域名订单',
        LayOut22: 'SSL订单',
        LayOut23: '工单',
        LayOut24: '工单列表',
        LayOut25: '提交工单',
        LayOut26: '财务管理',
        LayOut27: '在线充值',
        LayOut28: '余额明细',
        LayOut29: '账单列表',
        LayOut30: '退款列表',
        LayOut31: '推介计划',
        LayOut32: '官网',
        LayOut33: '工单',
        LayOut34: '账户信息',
        LayOut35: '账单列表',
        LayOut36: '退出登录',
        LayOut37: '扫码支付 ',
        LayOut38: '交易编号',
        LayOut39: '当前USDT支付区块网络协议为TRC20',
        LayOut40: '点击复制',
        LayOut41: '请在倒计时结束前完成付款！',
        LayOut42: '谷歌验证绑定',
        LayOut43: '请扫描下方二维码完成绑定',
        LayOut44: '用户操作验证',
        LayOut45: '验证方式',
        LayOut46: '谷歌验证',
        LayOut47: '邮箱验证',
        LayOut48: '验证码',
        LayOut49: '获取验证码',
        LayOut50: '还未绑定',
        LayOut51: '去绑定',
        LayOut52: '最近一天',
        LayOut53: '最近三天',
        LayOut54: '最近一周',
        LayOut55: '最近一个月',
        LayOut56: '最近三个月',
        LayOut57: '最近半年',
        LayOut58: '最近一年',
        LayOut59: '支付成功',
        LayOut60: '请先填写验证码',
        LayOut61: '订单列表',
        LayOut62: 'VPS列表',
        LayOut63: '到账金额需要与下方显示的',
        LayOut64: '金额一致',
        LayOut65: '，否则会不到账',
        Aff1: '推荐计划',
        Aff2: '还未开通推广链接',
        Aff3: '生成链接',
        Aff4: '推广链接',
        Aff5: '推广数据',
        Aff6: '佣金总额',
        Aff7: '可提现金额',
        Aff8: '处理中金额',
        Aff9: '无效佣金',
        Aff10: '点击次数',
        Aff11: '注册用户',
        Aff12: '立即提现',
        Aff13: '推广订单',
        Aff14: '创建时间',
        Aff15: '佣金',
        Aff16: '订购类型',
        Aff17: '新购',
        Aff18: '续费',
        Aff19: '二次订购',
        Aff20: '订单类型',
        Aff21: '状态',
        Aff22: '已确认',
        Aff23: '待确认',
        Aff24: '无效',
        Aff25: '提现记录',
        Aff26: '创建时间',
        Aff27: '提现佣金',
        Aff28: '实际支付佣金金额',
        Aff29: '提现类型',
        Aff30: '状态',
        Aff31: '审核通过',
        Aff32: '审核失败',
        Aff33: '待审核',
        Aff34: '注册用户',
        Aff35: '创建时间',
        Aff36: '用户名',
        Aff37: '邮箱', 
        Aff38: '电话',
        Aff39: '上一次登录时间',
        Aff40: '推广提现',
        Aff41: '提现方式',
        Aff42: '账户余额',
        Aff43: '银行卡',
        Aff44: 'Alipay',
        Aff45: 'USDT',
        Aff46: 'WeChat',
        Aff47: '账号',
        Aff48: '可以使用支付宝账号或银行卡号汇款、TRC20的钱包地址',
        Aff49: '姓名',
        Aff50: '如果是银行卡汇款，银行卡和姓名必须一致',
        Aff51: '提现金额',
        Aff52: '可提现金额',
        BalanceDetails1: '财务管理',
        BalanceDetails2: '余额明细',
        BalanceDetails3: '描述',
        BalanceDetails4: '订单类型',
        BalanceDetails5: '域名',
        BalanceDetails6: 'SSL证书',
        BalanceDetails7: '物理服务器',
        BalanceDetails8: '云服务器',
        BalanceDetails9: '增值服务',
        BalanceDetails10: 'VPN专线',
        BalanceDetails11: '充值',
        BalanceDetails12: '扣款',
        BalanceDetails13: '其他产品',
        BalanceDetails14: '创建时间',
        BalanceDetails15: '创建时间',
        BalanceDetails16: '交易前余额',
        BalanceDetails17: '交易后余额',
        BalanceDetails18: '余额变化',
        BalanceDetails19: '类型',
        BalanceDetails20: '描述',
        BalanceDetails21: '查看详情',
        BalanceDetails22: '明细描述',
        BalanceDetails23: '项目描述',
        BalanceDetails24: '项目金额',
        BalanceRecharge1: '财务管理',
        BalanceRecharge2: '在线充值',
        BalanceRecharge3: '在线充值',
        BalanceRecharge4: '当前余额',
        BalanceRecharge5: '充值金额',
        BalanceRecharge6: '支付方式',
        BalanceRecharge7: '提交订单',
        BalanceRecharge8: '请先输入要充值的金额哟',
        BalanceRefund1: '财务管理',
        BalanceRefund2: '退款列表',
        BalanceRefund3: '状态',
        BalanceRefund4: '待处理',
        BalanceRefund5: '已处理',
        BalanceRefund6: '已拒绝',
        BalanceRefund7: '已取消',
        BalanceRefund8: '已删除',
        BalanceRefund9: '创建时间',
        BalanceRefund10: '创建时间',
        BalanceRefund11: '申请退款金额',
        BalanceRefund12: '状态',
        BalanceRefund13: '待处理',
        BalanceRefund14: '已处理',
        BalanceRefund15: '已拒绝',
        BalanceRefund16: '已取消',
        BalanceRefund17: '已删除',
        BalanceRefund18: '资源类型',
        BalanceRefund19: '云主机',
        BalanceRefund20: '退款原因',
        BalanceRefund21: '操作',
        BalanceRefund22: '查看详情',
        BalanceRefund23: '物理机',
        BalanceRefund24: '域名',
        BalanceRefund25: 'SSL证书',
        BalanceRefund26: '资源ID',
        BalanceRefund27: '资源信息',
        BalanceRefundDetails1: '财务管理',
        BalanceRefundDetails2: '退款列表',
        BalanceRefundDetails3: '退款详情',
        BalanceRefundDetails4: '退款信息',
        BalanceRefundDetails5: '状态',
        BalanceRefundDetails6: '待处理',
        BalanceRefundDetails7: '已处理',
        BalanceRefundDetails8: '已拒绝',
        BalanceRefundDetails9: '已取消',
        BalanceRefundDetails10: '已删除',
        BalanceRefundDetails11: '取消退款',
        BalanceRefundDetails12: '创建时间',
        BalanceRefundDetails13: '申请退款金额',
        BalanceRefundDetails14: '实际退款金额',
        BalanceRefundDetails15: '退款方式',
        BalanceRefundDetails16: '余额',
        BalanceRefundDetails17: '原路退回',
        BalanceRefundDetails18: '其他',
        BalanceRefundDetails19: '资源类型',
        BalanceRefundDetails20: '云主机',
        BalanceRefundDetails21: '资源ID',
        BalanceRefundDetails22: '退款原因',
        BalanceRefundDetails23: '处理时间',
        BalanceRefundDetails24: '处理备注',
        BalanceRefundDetails25: '没有查询到该退款信息哟',
        CloudList1: '云主机管理',
        CloudList2: '云主机列表',
        CloudList3: '去选购',
        CloudList4: '主机名称',
        CloudList5: '业务状态',
        CloudList6: '正常',
        CloudList7: '禁用',
        CloudList8: '到期暂停',
        CloudList9: '试用',
        CloudList10: '已回收',
        CloudList11: '时间查询',
        CloudList12: '批量续费',
        CloudList13: '主机名称',
        CloudList14: '数据中心',
        CloudList15: '开通时间',
        CloudList16: '到期时间',
        CloudList17: '续费/月',
        CloudList18: '业务状态',
        CloudList19: '正常',
        CloudList20: '禁用',
        CloudList21: '到期暂停',
        CloudList22: '流量超额暂停',
        CloudList23: '试用',
        CloudList24: '已回收',
        CloudList25: '实例状态',
        CloudList26: '创建中',
        CloudList27: '运行中',
        CloudList28: '关机',
        CloudList29: '未知',
        CloudList30: '等待重启',
        CloudList31: '等待状态更新',
        CloudList32: '暂停',
        CloudList33: '挂起',
        CloudList34: '备注',
        CloudList35: '操作',
        CloudList36: '面板',
        CloudList37: '续费',
        CloudList38: '服务器续费',
        CloudList39: '服务器ID',
        CloudList40: '主机名称',
        CloudList41: '开通时间',
        CloudList42: '到期时间',
        CloudList43: '开通时间',
        CloudList44: '到期时间',
        CloudList45: '续费价格',
        CloudList46: '续费时长',
        CloudList47: '个月',
        CloudList48: '支付方式',
        CloudList49: '价格',
        CloudList50: '续费',
        CloudList51: '修改备注',
        CloudList52: '备注',
        CloudList53: '请先选择服务器哦',
        CloudList54: '支付成功',
        CloudManager1: '云主机管理',
        CloudManager2: '云主机列表',
        CloudManager3: '控制面板',
        CloudManager4: '控制台',
        CloudManager5: '新工单',
        CloudManager6: '开机',
        CloudManager7: '关机',
        CloudManager8: '重启',
        CloudManager9: '强制关机',
        CloudManager10: '强制重启',
        CloudManager11: '续费',
        CloudManager12: '退款',
        CloudManager13: '创建中',
        CloudManager14: '运行中',
        CloudManager15: '关机',
        CloudManager16: '未知',
        CloudManager17: '等待重启',
        CloudManager18: '等待状态更新',
        CloudManager19: '暂停',
        CloudManager20: '挂起',
        CloudManager21: '正在',
        CloudManager22: '复制实例信息',
        CloudManager23: '业务状态',
        CloudManager24: '正常',
        CloudManager25: '禁用',
        CloudManager26: '到期暂停',
        CloudManager27: '流量超额暂停',
        CloudManager28: '试用',
        CloudManager29: '已回收',
        CloudManager30: '数据中心',
        CloudManager31: '操作系统',
        CloudManager32: '开通时间',
        CloudManager33: '到期时间',
        CloudManager34: 'IP地址',
        CloudManager35: '重装系统',
        CloudManager36: '续费',
        CloudManager37: '拷贝全部',
        CloudManager38: '远程端口',
        CloudManager39: '实例用户名',
        CloudManager40: '实例密码',
        CloudManager41: '重置密码',
        CloudManager42: '救援模式',
        CloudManager43: '未开启',
        CloudManager44: '已开启',
        CloudManager45: '密码',
        CloudManager46: '进入救援系统',
        CloudManager47: '退出救援系统',
        CloudManager48: '备注',
        CloudManager49: '修改备注',
        CloudManager50: '流量概况',
        CloudManager51: 'CPU 使用率',
        CloudManager52: '概况',
        CloudManager53: '实例信息',
        CloudManager54: '复制配置信息',
        CloudManager55: '数据中心',
        CloudManager56: '到期时间',
        CloudManager57: '带宽/流量信息',
        CloudManager58: '网络类型',
        CloudManager59: '带宽大小',
        CloudManager60: 'IP地址',
        CloudManager61: '远程端口',
        CloudManager62: '配置信息',
        CloudManager63: '核',
        CloudManager64: '内存',
        CloudManager65: '系统盘',
        CloudManager66: '数据盘',
        CloudManager67: 'IP数',
        CloudManager68: '操作系统',
        CloudManager69: '计费信息',
        CloudManager70: '续费价格/月',
        CloudManager71: '续费价格/年',
        CloudManager72: '开通时间',
        CloudManager73: '到期时间',
        CloudManager74: '架构图',
        CloudManager75: '监控',
        CloudManager76: 'CPU使用率',
        CloudManager77: '磁盘使用率',
        CloudManager78: '内存使用率',
        CloudManager79: '网卡使用率',
        CloudManager80: '包转发率',
        CloudManager81: '网络',
        CloudManager82: '带宽/流量信息',
        CloudManager83: '上行带宽',
        CloudManager84: '下行带宽',
        CloudManager85: '月流量',
        CloudManager86: '网络',
        CloudManager87: '掩码',
        CloudManager88: '网关',
        CloudManager89: '安全组',
        CloudManager90: '创建时间',
        CloudManager91: '规则方向',
        CloudManager92: '入方向',
        CloudManager93: '出方向',
        CloudManager94: '授权类型',
        CloudManager95: '端口',
        CloudManager96: '授权IP',
        CloudManager97: '是否锁定',
        CloudManager98: '不锁定',
        CloudManager99: '锁定',
        CloudManager100: '备注',
        CloudManager101: '操作',
        CloudManager104: '名称',
        CloudManager105: '操作',
        CloudManager106: '新增',
        CloudManager107: '定时任务',
        CloudManager108: '创建任务',
        CloudManager109: '类型',
        CloudManager110: '快照',
        CloudManager111: '备份',
        CloudManager112: '频率',
        CloudManager113: '小时',
        CloudManager114: '天',
        CloudManager115: '周',
        CloudManager116: '月',
        CloudManager117: '开始创建时间',
        CloudManager118: '磁盘',
        CloudManager119: '创建时间',
        CloudManager120: '操作',
        CloudManager121: '修改主机名',
        CloudManager122: '新主机名',
        CloudManager123: '修改备注',
        CloudManager124: '备注',
        CloudManager125: '重置实例密码',
        CloudManager126: '新密码',
        CloudManager127: '随机生成',
        CloudManager128: '重装系统',
        CloudManager129: '操作系统',
        CloudManager130: '密码',
        CloudManager131: '随机生成',
        CloudManager132: '端口',
        CloudManager133: '是否只格式化系统',
        CloudManager134: '服务器续费',
        CloudManager135: '服务器ID',
        CloudManager136: '主机名称',
        CloudManager137: '开通时间',
        CloudManager138: '到期时间',
        CloudManager139: '续费时长',
        CloudManager140: '个月',
        CloudManager141: '支付方式',
        CloudManager142: '价格',
        CloudManager143: '续费',
        CloudManager144: '进入救援系统',
        CloudManager145: '救援系统类型',
        CloudManager146: '跟随实例',
        CloudManager147: 'windows中文版',
        CloudManager148: 'windows英文版',
        CloudManager149: '救援系统密码',
        CloudManager150: '随机生成',
        CloudManager151: '新增安全组规则',
        CloudManager152: '规则方向',
        CloudManager153: '入方向',
        CloudManager154: '出方向',
        CloudManager155: '授权类型',
        CloudManager156: '端口',
        CloudManager157: '授权IP (0.0.0.0/0 不限制)',
        CloudManager158: '是否锁定',
        CloudManager159: '不锁定',
        CloudManager160: '锁定',
        CloudManager161: '备注',
        CloudManager162: '创建定时任务',
        CloudManager163: '类型',
        CloudManager164: '定时快照',
        CloudManager165: '定时备份',
        CloudManager166: '磁盘选择',
        CloudManager167: '系统盘 ',
        CloudManager168: '数据盘 ',
        CloudManager169: '开始创建时间',
        CloudManager170: '频率',
        CloudManager171: '小时',
        CloudManager172: '天',
        CloudManager173: '周',
        CloudManager174: '月',
        CloudManager175: '注意：当可用备份/快照数量不足时，将自动覆盖最老的那一条数据',
        CloudManager176: '云服务器退款',
        CloudManager177: '服务器ID',
        CloudManager178: '主IP',
        CloudManager179: '服务器名称',
        CloudManager180: '开通时间',
        CloudManager181: '到期时间',
        CloudManager182: '退款金额',
        CloudManager183: '预计退款金额',
        CloudManager184: '具体以财务实际退款为准',
        CloudManager185: '退款原因',
        CloudManager186: '退款',
        CloudManager187: 'CPU使用率',
        CloudManager188: '读取速度',
        CloudManager189: '写入速度',
        CloudManager190: '读取',
        CloudManager191: '写入',
        CloudManager192: '总量',
        CloudManager193: '已用',
        CloudManager194: '接收',
        CloudManager195: '发送',
        CloudManager196: '接收包',
        CloudManager197: '发送包',
        CloudManager198: '请先输入新主机名哟',
        CloudManager199: '请先输入新密码哟',
        CloudManager200: '支付成功',
        CloudManager201: '请先输入密码哟',
        CloudManager202: '完成',
        CloudManager203: '请先选择要查询的时间哟',
        CloudManager204: '当前实例无可用快照数量哦',
        CloudManager205: '当前实例无可用备份数量哦',
        CloudManager206: '申请退款成功，可前往退款列表查看',
        CloudManager207: '提示',
        CloudManager208: '前往退款列表',
        DomainContacts1: '域名管理',
        DomainContacts2: '域名模板',
        DomainContacts3: '关键字',
        DomainContacts4: '邮箱',
        DomainContacts5: '电话',
        DomainContacts6: '状态',
        DomainContacts7: '启用',
        DomainContacts8: '禁用',
        DomainContacts9: '新建模板',
        DomainContacts10: '模板名称',
        DomainContacts11: '创建时间',
        DomainContacts12: '邮箱',
        DomainContacts13: '电话',
        DomainContacts14: '状态',
        DomainContacts15: '启用',
        DomainContacts16: '禁用',
        DomainContacts17: '操作',
        DomainContacts18: '编辑',
        DomainContactsAdd1: '域名管理',
        DomainContactsAdd2: '域名模板',
        DomainContactsAdd3: '新建域名模板',
        DomainContactsAdd4: '填写下面表格创建新的联系人资料，添加新的联系人不会改变已有域名的相关信息。',
        DomainContactsAdd5: '联系人信息',
        DomainContactsAdd6: '模板名称',
        DomainContactsAdd7: '公司名称',
        DomainContactsAdd8: '名字',
        DomainContactsAdd9: '姓氏',
        DomainContactsAdd10: '国家/地区',
        DomainContactsAdd11: '州/省',
        DomainContactsAdd12: '城市',
        DomainContactsAdd13: '邮政编码',
        DomainContactsAdd14: '邮箱',
        DomainContactsAdd15: '电话',
        DomainContactsAdd16: '联系地址',
        DomainContactsAdd17: '状态',
        DomainContactsAdd18: '启用',
        DomainContactsAdd19: '禁用',
        DomainContactsAdd20: '保存模板',
        DomainContactsAdd21: '返回',
        DomainContactsAdd22: '新建模板',
        DomainContactsAdd23: '模板详情',
        DomainDetails1: '域名管理',
        DomainDetails2: '域名列表',
        DomainDetails3: '域名解析',
        DomainDetails4: '添加解析',
        DomainDetails5: '主机名',
        DomainDetails6: '域名',
        DomainDetails7: '类型',
        DomainDetails8: '对应值',
        DomainDetails9: '优先级',
        DomainDetails10: '操作',
        DomainDetails11: 'DNS服务器',
        DomainDetails12: '编辑',
        DomainDetails13: '添加DNS服务器',
        DomainDetails14: '保存更改',
        DomainDetails15: '删除',
        DomainDetails16: '子域名网址转发',
        DomainDetails17: '添加网址转发',
        DomainDetails18: '主机名',
        DomainDetails19: '创建时间',
        DomainDetails20: '目标地址',
        DomainDetails21: '类型',
        DomainDetails22: 'meta信息',
        DomainDetails23: 'meta标题',
        DomainDetails24: 'meta描述',
        DomainDetails25: 'meta关键字',
        DomainDetails26: '操作',
        DomainDetails27: '域名详情',
        DomainDetails28: '域名续费',
        DomainDetails29: '域名退款',
        DomainDetails30: '域名信息',
        DomainDetails31: '域名',
        DomainDetails32: '状态',
        DomainDetails33: '正常',
        DomainDetails34: '到期',
        DomainDetails35: '已删除',
        DomainDetails36: '域名后缀',
        DomainDetails37: '注册时间',
        DomainDetails38: '到期时间',
        DomainDetails39: '注册价格/年',
        DomainDetails40: '续费价格/年',
        DomainDetails41: '域名联系人',
        DomainDetails42: '公司名称',
        DomainDetails43: '姓氏',
        DomainDetails44: '名字',
        DomainDetails45: '国家/地区',
        DomainDetails46: '州/省',
        DomainDetails47: '城市',
        DomainDetails48: '邮政编码',
        DomainDetails49: '邮箱',
        DomainDetails50: '电话',
        DomainDetails51: '联系地址',
        DomainDetails52: '域名续费',
        DomainDetails53: '域名',
        DomainDetails54: '注册时间',
        DomainDetails55: '到期时间',
        DomainDetails56: '续费时长',
        DomainDetails57: '年',
        DomainDetails58: '支付方式',
        DomainDetails59: '年付',
        DomainDetails60: '总价',
        DomainDetails61: '续费',
        DomainDetails62: '域名退款',
        DomainDetails63: '域名',
        DomainDetails64: '注册时间',
        DomainDetails65: '到期时间',
        DomainDetails66: '退款金额',
        DomainDetails67: '预计退款金额',
        DomainDetails68: '具体以财务实际退款为准',
        DomainDetails69: '退款原因',
        DomainDetails70: '退款',
        DomainDetails71: '添加解析',
        DomainDetails72: '修改解析',
        DomainDetails73: '主机名',
        DomainDetails74: '请输入,为空则为根域名',
        DomainDetails75: '类型',
        DomainDetails76: '对应值',
        DomainDetails77: '优先级',
        DomainDetails78: '请输入，如果未提供，则默认为 10',
        DomainDetails79: '添加网址转发',
        DomainDetails80: '主机名',
        DomainDetails81: '目标地址',
        DomainDetails82: '转发方法',
        DomainDetails83: 'META 标题',
        DomainDetails84: 'META 描述',
        DomainDetails85: 'META 关键字',
        DomainDetails86: '支付成功',
        DomainDetails87: '温馨提示：初次注册的域名默认的解析记录请务必删除掉，否则解析可能不会生效！',
        DomainDetails88: '主域名网址转发',
        DomainDetails89: '当前域名已被注册局停止解析，添加解析也不会生效，如有疑问，请联系客服！',
        DomainList1: '域名管理',
        DomainList2: '域名列表',
        DomainList3: '去选购',
        DomainList4: '域名',
        DomainList5: '状态',
        DomainList6: '正常',
        DomainList7: '到期',
        DomainList8: '已删除',
        DomainList9: '时间查询',
        DomainList10: '域名',
        DomainList11: '注册时间',
        DomainList12: '到期时间',
        DomainList13: '状态',
        DomainList14: '正常',
        DomainList15: '到期',
        DomainList16: '已删除',
        DomainList17: '注册价格/年',
        DomainList18: '操作',
        DomainList19: '管理',
        DomainList20: '续费',
        DomainList21: '域名续费',
        DomainList22: '域名',
        DomainList23: '注册时间',
        DomainList24: '到期时间',
        DomainList25: '续费时长',
        DomainList26: '年',
        DomainList27: '支付方式',
        DomainList28: '年付',
        DomainList29: '总价',
        DomainList30: '续费',
        DomainList31: '域名退款',
        DomainList32: '域名',
        DomainList33: '注册时间',
        DomainList34: '到期时间',
        DomainList35: '退款金额',
        DomainList36: '预计退款金额',
        DomainList37: '具体以财务实际退款为准',
        DomainList38: '退款原因',
        DomainList39: '退款',
        DomainList40: '支付成功',
        ServerList1: '物理机管理',
        ServerList2: '服务器列表',
        ServerList3: '去选购',
        ServerList4: '产品名称',
        ServerList5: '状态',
        ServerList6: '正常',
        ServerList7: '已到期',
        ServerList8: '试用',
        ServerList9: '时间查询',
        ServerList10: '批量续费',
        ServerList11: '产品名称',
        ServerList12: '主IP',
        ServerList13: '业务IP',
        ServerList14: '拷贝全部',
        ServerList15: '开通时间',
        ServerList16: '到期时间',
        ServerList17: '续费/月',
        ServerList18: '状态',
        ServerList19: '正常',
        ServerList20: '已到期',
        ServerList21: '已退款',
        ServerList22: '试用',
        ServerList23: '备注',
        ServerList24: '操作',
        ServerList25: '面板',
        ServerList26: '续费',
        ServerList27: '服务器续费',
        ServerList28: '服务器ID',
        ServerList29: '主IP',
        ServerList30: '服务器名称',
        ServerList31: '主IP',
        ServerList32: '续费价格',
        ServerList33: '续费时长',
        ServerList34: '个月',
        ServerList35: '支付方式',
        ServerList36: '价格',
        ServerList37: '修改备注',
        ServerList38: '备注',
        ServerList39: '请先选择服务器哦',
        ServerList40: '支付成功',
        ServerList41: '待开通',
        ServerList42: '支付金额',
        ServerList43: '已回收',
        ServerManager1: '物理机管理',
        ServerManager2: '服务器列表',
        ServerManager3: '控制面板',
        ServerManager4: '取消重装',
        ServerManager5: '控制面板',
        ServerManager6: '订单列表',
        ServerManager7: '开机',
        ServerManager8: '关机',
        ServerManager9: '重启',
        ServerManager10: '重装系统',
        ServerManager11: '续费',
        ServerManager12: '退款',
        ServerManager13: '服务器信息',
        ServerManager14: '主IP',
        ServerManager15: '业务IP',
        ServerManager16: '拷贝全部',
        ServerManager17: '业务状态',
        ServerManager18: '正常',
        ServerManager19: '已到期',
        ServerManager20: '已销毁',
        ServerManager21: '试用',
        ServerManager22: '用户名',
        ServerManager23: '密码',
        ServerManager24: '端口',
        ServerManager25: '网关',
        ServerManager26: '子网掩码',
        ServerManager27: '操作系统',
        ServerManager28: '备注',
        ServerManager29: '控制面板',
        ServerManager30: '产品名称',
        ServerManager31: '开通时间',
        ServerManager32: '到期时间',
        ServerManager33: '续费价格/月',
        ServerManager34: '续费价格/年',
        ServerManager35: '服务器编号',
        ServerManager36: '配置信息',
        ServerManager37: '流量图',
        ServerManager38: '最近12小时',
        ServerManager39: '最近1天',
        ServerManager40: '最近3天',
        ServerManager41: '最近7天',
        ServerManager42: '最近30天',
        ServerManager43: '全部',
        ServerManager44: '暂无流量图信息哟',
        ServerManager45: '主订单',
        ServerManager46: '裸机',
        ServerManager47: '硬盘',
        ServerManager48: '内存',
        ServerManager49: '防御',
        ServerManager50: '流量',
        ServerManager51: '带宽',
        ServerManager52: '其他',
        ServerManager53: '新开',
        ServerManager54: '续费',
        ServerManager55: '已支付',
        ServerManager56: '未支付',
        ServerManager57: '已退款',
        ServerManager58: '未生效',
        ServerManager59: '已生效',
        ServerManager60: '已取消',
        ServerManager61: '已退款',
        ServerManager62: '订单ID',
        ServerManager63: '订单号',
        ServerManager64: '订单类型',
        ServerManager65: '新开',
        ServerManager66: '续费',
        ServerManager67: '创建时间',
        ServerManager68: '购买时长',
        ServerManager69: '试用',
        ServerManager70: '月',
        ServerManager71: '季度',
        ServerManager72: '半年',
        ServerManager73: '年',
        ServerManager74: '购买数量',
        ServerManager75: '实际支付价格',
        ServerManager76: '订单描述',
        ServerManager77: '查看详情',
        ServerManager78: '重装系统',
        ServerManager79: '操作系统',
        ServerManager80: '密码',
        ServerManager81: '随机生成',
        ServerManager82: '端口',
        ServerManager83: '是否只格式化系统',
        ServerManager84: '服务器续费',
        ServerManager85: '服务器ID',
        ServerManager86: '主IP',
        ServerManager87: '服务器名称',
        ServerManager88: '开通时间',
        ServerManager89: '到期时间',
        ServerManager90: '续费时长',
        ServerManager91: '个月',
        ServerManager92: '支付方式',
        ServerManager93: '价格',
        ServerManager94: '续费',
        ServerManager95: '重置密码',
        ServerManager96: '新密码',
        ServerManager97: '随机生成',
        ServerManager98: '修改备注',
        ServerManager99: '备注',
        ServerManager100: '服务器退款',
        ServerManager101: '服务器ID',
        ServerManager102: '主IP',
        ServerManager103: '服务器名称',
        ServerManager104: '开通时间',
        ServerManager105: '到期时间',
        ServerManager106: '退款金额',
        ServerManager107: '预计退款金额',
        ServerManager108: '具体以财务实际退款为准',
        ServerManager109: '退款原因',
        ServerManager110: '退款',
        ServerManager111: '操作系统重装进度',
        ServerManager112: '请先选择要查询的时间哟',
        ServerManager113: '支付成功',
        ServerManager114: '待开通',
        ServerManager115: '内网IP',
        ServerManager116: '日志记录',
        ServerManager117: '创建时间',
        ServerManager118: '类型',
        ServerManager119: '操作IP',
        ServerManager120: '标题',
        ServerManager121: '详情',
        ServerManager122: '查看',
        VpsList1: 'VPS管理',
        VpsList2: 'VPS列表',
        VpsList3: '去选购',
        VpsList4: '产品名称',
        VpsList5: '状态',
        VpsList6: '正常',
        VpsList7: '已到期',
        VpsList8: '试用',
        VpsList9: '时间查询',
        VpsList10: '批量续费',
        VpsList11: '产品名称',
        VpsList12: '主IP',
        VpsList13: '业务IP',
        VpsList14: '拷贝全部',
        VpsList15: '开通时间',
        VpsList16: '到期时间',
        VpsList17: '续费/月',
        VpsList18: '状态',
        VpsList19: '正常',
        VpsList20: '已到期',
        VpsList21: '已退款',
        VpsList22: '试用',
        VpsList23: '备注',
        VpsList24: '操作',
        VpsList25: '面板',
        VpsList26: '续费',
        VpsList27: 'VPS续费',
        VpsList28: 'VPS ID',
        VpsList29: '主IP',
        VpsList30: 'VPS名称',
        VpsList31: '主IP',
        VpsList32: '续费价格',
        VpsList33: '续费时长',
        VpsList34: '个月',
        VpsList35: '支付方式',
        VpsList36: '价格',
        VpsList37: '修改备注',
        VpsList38: '备注',
        VpsList39: '请先选择VPS哦',
        VpsList40: '支付成功',
        VpsList41: '待开通',
        VpsList42: '支付金额',
        VpsList43: '已暂停',
        VpsList44: '关机',
        VpsManager1: 'VPS管理',
        VpsManager2: 'VPS列表',
        VpsManager3: '控制面板',
        VpsManager4: '控制台',
        VpsManager5: '开机',
        VpsManager6: '关机',
        VpsManager7: '重启',
        VpsManager8: '强制关机',
        VpsManager9: '强制重启',
        VpsManager10: '续费',
        VpsManager11: '退款',
        VpsManager12: '已使用流量',
        VpsManager13: '流量总量',
        VpsManager14: '主IP',
        VpsManager15: '重置密码',
        VpsManager16: '默认',
        VpsManager17: '重装系统',
        VpsManager18: '修改备注',
        VpsManager19: '概况',
        VpsManager20: '配置信息',
        VpsManager21: '监控',
        VpsManager22: '带宽使用率',
        VpsManager23: '内存使用量',
        VpsManager24: 'CPU使用率',
        VpsManager25: '硬盘使用率',
        SslContacts1: 'SSL管理',
        SslContacts2: 'SSL模板',
        SslContacts3: '模板名称',
        SslContacts4: '新建模板',
        SslContacts5: '批量删除',
        SslContacts6: '模板名称',
        SslContacts7: '创建时间',
        SslContacts8: '姓名',
        SslContacts9: '邮箱',
        SslContacts10: '手机',
        SslContacts11: '操作',
        SslContacts12: '编辑',
        SslContacts13: '请先选择模板哦',
        SslContactsAdd1: 'SSL管理',
        SslContactsAdd2: 'SSL模板',
        SslContactsAdd3: '新建SSL联系人模板',
        SslContactsAdd4: '填写下面表格创建新的联系人资料，添加新的联系人不会改变已有SSL的相关信息。',
        SslContactsAdd5: '模板信息',
        SslContactsAdd6: '模板名称',
        SslContactsAdd7: '管理员信息',
        SslContactsAdd8: '名字',
        SslContactsAdd9: '姓氏',
        SslContactsAdd10: '邮箱',
        SslContactsAdd11: '手机号码',
        SslContactsAdd12: '职业',
        SslContactsAdd13: '机构',
        SslContactsAdd14: '国家/地区',
        SslContactsAdd15: '州/省',
        SslContactsAdd16: '城市',
        SslContactsAdd17: '邮政编码',
        SslContactsAdd18: '地址',
        SslContactsAdd19: '技术支持联系信息',
        SslContactsAdd20: '与管理员信息相同',
        SslContactsAdd21: '当 SSL 证书类型是企业机构证书时，需要提供技术支持的联系信息。',
        SslContactsAdd22: '财务联系信息',
        SslContactsAdd23: '组织联系信息',
        SslContactsAdd24: '机构',
        SslContactsAdd25: '手机号码',
        SslContactsAdd26: '国家/地区',
        SslContactsAdd27: '城市',
        SslContactsAdd28: '邮政编码',
        SslContactsAdd29: '地址',
        SslContactsAdd30: '保存模板',
        SslContactsAdd31: '返回',
        SslContactsAdd32: '新建模板',
        SslContactsAdd33: '请填写模板名称哦',
        SslContactsAdd34: '模板详情',
        Ticket1: '工单',
        Ticket2: '工单列表',
        Ticket3: '标题',
        Ticket4: '标题',
        Ticket5: '创建时间',
        Ticket6: '产品类型',
        Ticket7: '状态',
        Ticket8: '已开启',
        Ticket9: '处理中',
        Ticket10: '用户已回复',
        Ticket11: '工程师已回复',
        Ticket12: '已关闭',
        Ticket13: '已删除',
        Ticket14: '工程师已读',
        Ticket15: '未读',
        Ticket16: '已读',
        Ticket17: '操作',
        Ticket18: '查看详情',
        Ticket19: '是否确定关闭工单',
        Ticket20: '关闭工单',
        TicketAdd1: '工单',
        TicketAdd2: '提交工单',
        TicketAdd3: '新建工单',
        TicketAdd4: '工单标题',
        TicketAdd5: '工单类型',
        TicketAdd6: '服务器',
        TicketAdd7: '域名',
        TicketAdd8: '云服务器',
        TicketAdd9: 'SSL证书',
        TicketAdd10: '其他',
        TicketAdd11: '服务产品',
        TicketAdd12: '无数据',
        TicketAdd13: '工单内容',
        TicketAdd14: '提交工单',
        TicketAdd15: '请填写工单标题哦',
        TicketAdd16: '请选择工单类型哦',
        TicketAdd17: '请选择服务产品哦',
        TicketAdd18: '请填写工单内容哦',
        TicketAdd19: '工单分类',
        TicketAdd20: '请填写工单分类哦',
        TicketDetails1: '工单',
        TicketDetails2: '工单列表',
        TicketDetails3: '工单详情',
        TicketDetails4: '标题',
        TicketDetails5: '创建时间',
        TicketDetails6: '产品类型',
        TicketDetails7: '产品ID',
        TicketDetails8: '工单状态',
        TicketDetails9: '已开启',
        TicketDetails10: '处理中',
        TicketDetails11: '用户已回复',
        TicketDetails12: '工程师已回复',
        TicketDetails13: '已关闭',
        TicketDetails14: '已删除',
        TicketDetails15: '工程师已读',
        TicketDetails16: '未读',
        TicketDetails17: '已读',
        TicketDetails18: '消息记录',
        TicketDetails19: '用户',
        TicketDetails20: '系统',
        TicketDetails21: '工程师',
        TicketDetails22: '财务',
        TicketDetails23: '用户',
        TicketDetails24: '系统',
        TicketDetails25: '工程师',
        TicketDetails26: '财务',
        TicketDetails27: '消息回复',
        TicketDetails28: '回复',
        TicketDetails29: '请填写要回复的内容哦',
        TicketDetails30: '资源信息',
        UserInfo1: '账户管理',
        UserInfo2: '账户信息',
        UserInfo3: '基本信息',
        UserInfo4: '账户ID',
        UserInfo5: '用户名',
        UserInfo6: '最后登录IP',
        UserInfo7: '最后登录时间',
        UserInfo8: '登录信息',
        UserInfo9: '邮箱',
        UserInfo10: '手机号',
        UserInfo11: '密码',
        UserInfo12: '修改',
        UserInfo13: '个人信息',
        UserInfo14: '编辑',
        UserInfo15: '保存',
        UserInfo16: '姓氏',
        UserInfo17: '名字',
        UserInfo18: '公司名称',
        UserInfo19: '地区',
        UserInfo20: '国家/地区',
        UserInfo21: '州/省',
        UserInfo22: '城市',
        UserInfo23: '联系地址',
        UserInfo24: '邮政编码',
        UserInfo25: '修改密码',
        UserInfo26: '原密码',
        UserInfo27: '新密码',
        UserInfo28: '重复新密码',
        UserInfo29: '确认更改',
        UserInfo30: '敏感操作验证',
        UserInfo31: '谷歌验证',
        UserInfo32: '已绑定',
        UserInfo33: '解除绑定',
        UserInfo34: '请扫描二维码绑定',
        UserInfo35: '动态验证码',
        UserInfo36: '绑定',
        UserNotice1: '通知设置',
        UserNotice2: 'Telegram通知',
        UserNotice3: '如果您不知道您的电报ID是多少，您可以先关注我们的官方机器人',
        UserNotice4: '向机器人发送命令：获取ID，他会将您的ID返回给您',
        UserNotice5: '邮件系统通知',
        UserNotice6: '保存更改',
        UserNotice7: '请先输入Telegram ID哦',
        UserNotice8: '价格显示通知',
        UserLoginLog1: '账户管理',
        UserLoginLog2: '登录日志',
        UserLoginLog3: 'IP地址',
        UserLoginLog4: '状态',
        UserLoginLog5: '成功',
        UserLoginLog6: '失败',
        UserLoginLog7: '时间查询',
        UserLoginLog8: '操作信息',
        UserLoginLog9: '操作时间',
        UserLoginLog10: 'IP地址',
        UserLoginLog11: '状态',
        UserLoginLog12: '成功',
        UserLoginLog13: '失败',
        UserCoupons1: '账户管理',
        UserCoupons2: '优惠卷列表',
        UserCoupons3: '名称',
        UserCoupons4: '消费门槛',
        UserCoupons5: '优惠卷金额',
        UserCoupons6: '折扣',
        UserCoupons7: '有效天数',
        UserCoupons8: '类型',
        UserCoupons9: '满减卷',
        UserCoupons10: '折扣券',
        UserCoupons11: '代金券',
        UserCoupons12: '状态',
        UserCoupons13: '未使用',
        UserCoupons14: '已使用',
        UserCoupons15: '使用场景',
        UserCoupons16: '通用',
        UserCoupons17: '物理机',
        UserCoupons18: '云服务器',
        UserCoupons19: '域名',
        UserCoupons20: '到期时间',
        UserCoupons21: '是否到期',
        UserCoupons22: '已到期',
        UserCoupons23: '未到期',
        UserCoupons24: '领取时间',
        BalanceBill1: '订单管理',
        BalanceBill2: '订单列表',
        BalanceBill3: '订单编号',
        BalanceBill4: '创建时间',
        BalanceBill5: '支付订单编号',
        BalanceBill6: '创建时间',
        BalanceBill7: '订单金额',
        BalanceBill8: '实际支付金额',
        BalanceBill9: '支付方式',
        BalanceBill10: '支付状态',
        BalanceBill11: '支付成功',
        BalanceBill12: '未支付',
        BalanceBill13: '已退款',
        BalanceBill14: '操作',
        BalanceBill15: '部分退款',
        BalanceBill16: '交易过期',
        BalanceBillDetails1: '用户中心',
        BalanceBillDetails2: '订单管理',
        BalanceBillDetails3: '订单列表',
        BalanceBillDetails4: '订单详情',
        BalanceBillDetails5: '订单编号',
        BalanceBillDetails6: '打印',
        BalanceBillDetails7: '下载',
        BalanceBillDetails8: '订单类型',
        BalanceBillDetails9: '创建时间',
        BalanceBillDetails10: '未支付',
        BalanceBillDetails11: '支付成功',
        BalanceBillDetails12: '已退款',
        BalanceBillDetails13: '支付给',
        BalanceBillDetails14: '开票给',
        BalanceBillDetails15: '账单项目',
        BalanceBillDetails16: '描述',
        BalanceBillDetails17: '订单状态',
        BalanceBillDetails18: '管理',
        BalanceBillDetails19: '金额',
        BalanceBillDetails20: '已支付',
        BalanceBillDetails21: '未支付',
        BalanceBillDetails22: '已退款',
        BalanceBillDetails23: '发起支付金额',
        BalanceBillDetails24: '已支付金额',
        BalanceBillDetails25: '账单金额',
        BalanceBillDetails26: '退款金额',
        BalanceBillDetails27: '支付方式',
        BalanceBillDetails28: '立即支付',
        BalanceBillDetails29: '支付方式',
        BalanceBillDetails30: '支付成功',
        BalanceBillDetails31: '物理服务器',
        BalanceBillDetails32: '云服务器',
        BalanceBillDetails33: 'ssl证书',
        BalanceBillDetails34: '域名',
        BalanceBillDetails35: '余额充值',
        BalanceBillDetails36: '充值成功',
        BalanceBillDetails37: '未支付',
        BalanceBillDetails38: '未到账',
        BalanceBillDetails39: '未付款 信用额',
        BalanceBillDetails40: '支付失败',
        BalanceBillDetails41: '优惠卷抵扣',
        SslList1: 'SSL管理',
        SslList2: 'SSL列表',
        SslList3: '去选购',
        SslList4: '产品名称',
        SslList5: '域名',
        SslList6: '证书单号/CA/实例号',
        SslList7: '支付订单号',
        SslList8: '时间查询',
        SslList9: '解析主机',
        SslList10: '解析方式',
        SslList11: '解析值',
        SslList12: '产品名称',
        SslList13: '主域名',
        SslList14: 'CA订单号',
        SslList15: '实例号',
        SslList16: '购买时间',
        SslList17: '状态',
        SslList18: '已取消',
        SslList19: '申请成功',
        SslList20: '申请中',
        SslList21: '已到期',
        SslList22: '已重签',
        SslList23: '申请失败',
        SslList24: '已续费',
        SslList25: '已吊销',
        SslList26: '退款',
        SslList27: '待提交',
        SslList28: '签发状态',
        SslList29: '未完成',
        SslList30: '已完成',
        SslList31: '验证中',
        SslList32: '验证状态',
        SslList33: '未完成',
        SslList34: '已完成',
        SslList35: '验证中',
        SslList36: '操作',
        SslList37: '管理证书',
        SslList38: '域名验证',
        SslList39: 'SSL证书信息',
        SslList40: '通道',
        SslList41: '证书品牌',
        SslList42: '证书类型',
        SslList43: '域名类型',
        SslList44: '单域名',
        SslList45: '多域名',
        SslList46: '通配符',
        SslList47: '域名数量',
        SslList48: '单域名验证',
        SslList49: '多域名验证',
        SslList50: '请填写主域名，无需填写 * 号。如 example.com 覆盖所有 *.example.com 域名，a.example.com 覆盖所有 *.a.example.com 域名。',
        SslList51: '通配符验证',
        SslList52: '域名',
        SslList53: '验证规则',
        SslList54: '增加域名',
        SslList55: '联系信息',
        SslList56: '新建模板',
        SslList57: '还没有创建信息模板哟',
        SslList58: '姓名',
        SslList59: '邮箱',
        SslList60: '手机',
        SslList61: '提交申请',
        SslList62: 'DNS验证',
        SslList63: 'http文件验证',
        SslList64: 'https文件验证',
        SslList65: '邮箱验证',
        SslList66: '请先完整填写域名信息和验证规则哦',
    },
    // 繁体中文
    'tw': {
        common1: '沒有查找到數據喲~',
        common2: '取消',
        common3: '關閉',
        common4: '請輸入',
        common5: '確定',
        common6: '用戶中心',
        common7: '請選擇',
        common8: '請先完善表單內容哦~',
        common9: '開始時間',
        common10: '結束時間',
        common11: '查詢',
        common12: '重置',
        common13: '是否確定刪除',
        common14: '刪除',
        common15: '沒有查詢到該訂單信息喲',
        tools1: '文本已復製到剪貼板',
        tools2: '復製到剪貼板失敗',
        Home1: '用戶ID',
        Home2: '最後一次登入時間',
        Home3: '最後一次登入IP',
        Home4: '帳戶餘額',
        Home5: '立即充值',
        Home6: '餘額明細',
        Home7: '優惠卷',
        Home8: '查看',
        Home9: '工單處理',
        Home10: '客戶經理',
        Home11: '售後客服',
        Home12: '通路經理',
        Home13: '幫助中心',
        Home14: '專屬客服',
        Home15: '線上諮詢',
        Home16: '提交工單',
        Home17: '近期數據',
        Home18: '有效服務器',
        Home19: '有效功能變數名稱',
        Home20: '7天內到期物理機',
        Home21: '7天內到期VPS',
        Home22: '7天內到期雲服務器',
        Home23: '公告通知',
        Home24: '通知',
        Home25: '產品服務',
        Home26: '域名',
        Home27: '物理機',
        Home28: 'SSL證書',
        Home29: '雲服務器',
        Home30: '幫助文檔',
        Home31: '檔案',
        Home32: '暫無該聯系方式',
        LayOut1: '控製臺',
        LayOut2: '用戶中心',
        LayOut3: '域名管理',
        LayOut4: '域名列表',
        LayOut5: '域名模板',
        LayOut6: '物理機管理',
        LayOut7: '服務器列表',
        LayOut8: '雲主機管理',
        LayOut9: '雲主機列表',
        LayOut10: 'VPS管理',
        LayOut11: 'SSL管理',
        LayOut12: 'SSL列表',
        LayOut13: 'SSL模板',
        LayOut14: '賬戶管理',
        LayOut15: '賬戶信息',
        LayOut16: '登錄日誌',
        LayOut17: '通知設置',
        LayOut18: '訂單管理',
        LayOut19: '物理機訂單',
        LayOut20: '雲主機訂單',
        LayOut21: '域名訂單',
        LayOut22: 'SSL訂單',
        LayOut23: '工單',
        LayOut24: '工單列表',
        LayOut25: '提交工單',
        LayOut26: '財務管理',
        LayOut27: '在線充值',
        LayOut28: '余額明細',
        LayOut29: '賬單列表',
        LayOut30: '退款列表',
        LayOut31: '推介計劃',
        LayOut32: '官網',
        LayOut33: '工單',
        LayOut34: '賬戶信息',
        LayOut35: '賬單列表',
        LayOut36: '退出登錄',
        LayOut37: '掃碼支付 ',
        LayOut38: '交易編號',
        LayOut39: '當前USDT支付區塊網絡協議為TRC20',
        LayOut40: '點擊復製',
        LayOut41: '請在倒計時結束前完成付款！',
        LayOut42: '谷歌驗證綁定',
        LayOut43: '請掃描下方二維碼完成綁定',
        LayOut44: '用戶操作驗證',
        LayOut45: '驗證方式',
        LayOut46: '谷歌驗證',
        LayOut47: '郵箱驗證',
        LayOut48: '驗證碼',
        LayOut49: '獲取驗證碼',
        LayOut50: '還未綁定',
        LayOut51: '去綁定',
        LayOut52: '最近一天',
        LayOut53: '最近三天',
        LayOut54: '最近一周',
        LayOut55: '最近一個月',
        LayOut56: '最近三個月',
        LayOut57: '最近半年',
        LayOut58: '最近一年',
        LayOut59: '支付成功',
        LayOut60: '請先填寫驗證碼',
        LayOut61: '訂單列表',
        LayOut62: 'VPS列表',
        LayOut63: '到賬金額需要與下方顯示的',
        LayOut64: '金額一致',
        LayOut65: '，否則會不到賬',
        Aff1: '推薦計劃',
        Aff2: '還未開通推廣鏈接',
        Aff3: '生成鏈接',
        Aff4: '推廣鏈接',
        Aff5: '推廣數據',
        Aff6: '傭金總額',
        Aff7: '可提現金額',
        Aff8: '處理中金額',
        Aff9: '無效傭金',
        Aff10: '點擊次數',
        Aff11: '註冊用戶',
        Aff12: '立即提現',
        Aff13: '推廣訂單',
        Aff14: '創建時間',
        Aff15: '傭金',
        Aff16: '訂購類型',
        Aff17: '新購',
        Aff18: '續費',
        Aff19: '二次訂購',
        Aff20: '訂單類型',
        Aff21: '狀態',
        Aff22: '已確認',
        Aff23: '待確認',
        Aff24: '無效',
        Aff25: '提現記錄',
        Aff26: '創建時間',
        Aff27: '提現傭金',
        Aff28: '實際支付傭金金額',
        Aff29: '提現類型',
        Aff30: '狀態',
        Aff31: '審核通過',
        Aff32: '審核失敗',
        Aff33: '待審核',
        Aff34: '註冊用戶',
        Aff35: '創建時間',
        Aff36: '用戶名',
        Aff37: '郵箱', 
        Aff38: '電話',
        Aff39: '上一次登錄時間',
        Aff40: '推廣提現',
        Aff41: '提現方式',
        Aff42: '賬戶余額',
        Aff43: '銀行卡',
        Aff44: 'Alipay',
        Aff45: 'USDT',
        Aff46: 'WeChat',
        Aff47: '賬號',
        Aff48: '可以使用支付寶賬號或銀行卡號匯款、TRC20的錢包地址',
        Aff49: '姓名',
        Aff50: '如果是銀行卡匯款，銀行卡和姓名必須一致',
        Aff51: '提現金額',
        Aff52: '可提現金額',
        BalanceDetails1: '財務管理',
        BalanceDetails2: '余額明細',
        BalanceDetails3: '描述',
        BalanceDetails4: '訂單類型',
        BalanceDetails5: '域名',
        BalanceDetails6: 'SSL證書',
        BalanceDetails7: '物理服務器',
        BalanceDetails8: '雲服務器',
        BalanceDetails9: '增值服務',
        BalanceDetails10: 'VPN專線',
        BalanceDetails11: '充值',
        BalanceDetails12: '扣款',
        BalanceDetails13: '其他產品',
        BalanceDetails14: '創建時間',
        BalanceDetails15: '創建時間',
        BalanceDetails16: '交易前余額',
        BalanceDetails17: '交易後余額',
        BalanceDetails18: '余額變化',
        BalanceDetails19: '類型',
        BalanceDetails20: '描述',
        BalanceDetails21: '查看詳情',
        BalanceDetails22: '明細描述',
        BalanceDetails23: '項目描述',
        BalanceDetails24: '項目金額',
        BalanceRecharge1: '財務管理',
        BalanceRecharge2: '在線充值',
        BalanceRecharge3: '在線充值',
        BalanceRecharge4: '當前余額',
        BalanceRecharge5: '充值金額',
        BalanceRecharge6: '支付方式',
        BalanceRecharge7: '提交訂單',
        BalanceRecharge8: '請先輸入要充值的金額喲',
        BalanceRefund1: '財務管理',
        BalanceRefund2: '退款列表',
        BalanceRefund3: '狀態',
        BalanceRefund4: '待處理',
        BalanceRefund5: '已處理',
        BalanceRefund6: '已拒絕',
        BalanceRefund7: '已取消',
        BalanceRefund8: '已刪除',
        BalanceRefund9: '創建時間',
        BalanceRefund10: '創建時間',
        BalanceRefund11: '申請退款金額',
        BalanceRefund12: '狀態',
        BalanceRefund13: '待處理',
        BalanceRefund14: '已處理',
        BalanceRefund15: '已拒絕',
        BalanceRefund16: '已取消',
        BalanceRefund17: '已刪除',
        BalanceRefund18: '資源類型',
        BalanceRefund19: '雲主機',
        BalanceRefund20: '退款原因',
        BalanceRefund21: '操作',
        BalanceRefund22: '查看詳情',
        BalanceRefund23: '物理機',
        BalanceRefund24: '域名',
        BalanceRefund25: 'SSL證書',
        BalanceRefund26: '資源ID',
        BalanceRefund27: '资源信息',
        BalanceRefundDetails1: '財務管理',
        BalanceRefundDetails2: '退款列表',
        BalanceRefundDetails3: '退款詳情',
        BalanceRefundDetails4: '退款信息',
        BalanceRefundDetails5: '狀態',
        BalanceRefundDetails6: '待處理',
        BalanceRefundDetails7: '已處理',
        BalanceRefundDetails8: '已拒絕',
        BalanceRefundDetails9: '已取消',
        BalanceRefundDetails10: '已刪除',
        BalanceRefundDetails11: '取消退款',
        BalanceRefundDetails12: '創建時間',
        BalanceRefundDetails13: '申請退款金額',
        BalanceRefundDetails14: '實際退款金額',
        BalanceRefundDetails15: '退款方式',
        BalanceRefundDetails16: '余額',
        BalanceRefundDetails17: '原路退回',
        BalanceRefundDetails18: '其他',
        BalanceRefundDetails19: '資源類型',
        BalanceRefundDetails20: '雲主機',
        BalanceRefundDetails21: '資源ID',
        BalanceRefundDetails22: '退款原因',
        BalanceRefundDetails23: '處理時間',
        BalanceRefundDetails24: '處理備註',
        BalanceRefundDetails25: '沒有查詢到該退款信息喲',
        CloudList1: '雲主機管理',
        CloudList2: '雲主機列表',
        CloudList3: '去選購',
        CloudList4: '主機名稱',
        CloudList5: '業務狀態',
        CloudList6: '正常',
        CloudList7: '禁用',
        CloudList8: '到期暫停',
        CloudList9: '試用',
        CloudList10: '已回收',
        CloudList11: '時間查詢',
        CloudList12: '批量續費',
        CloudList13: '主機名稱',
        CloudList14: '數據中心',
        CloudList15: '開通時間',
        CloudList16: '到期時間',
        CloudList17: '續費/月',
        CloudList18: '業務狀態',
        CloudList19: '正常',
        CloudList20: '禁用',
        CloudList21: '到期暫停',
        CloudList22: '流量超額暫停',
        CloudList23: '試用',
        CloudList24: '已回收',
        CloudList25: '實例狀態',
        CloudList26: '創建中',
        CloudList27: '運行中',
        CloudList28: '關機',
        CloudList29: '未知',
        CloudList30: '等待重啟',
        CloudList31: '等待狀態更新',
        CloudList32: '暫停',
        CloudList33: '掛起',
        CloudList34: '備註',
        CloudList35: '操作',
        CloudList36: '面板',
        CloudList37: '續費',
        CloudList38: '服務器續費',
        CloudList39: '服務器ID',
        CloudList40: '主機名稱',
        CloudList41: '開通時間',
        CloudList42: '到期時間',
        CloudList43: '開通時間',
        CloudList44: '到期時間',
        CloudList45: '續費價格',
        CloudList46: '續費時長',
        CloudList47: '個月',
        CloudList48: '支付方式',
        CloudList49: '價格',
        CloudList50: '續費',
        CloudList51: '修改備註',
        CloudList52: '備註',
        CloudList53: '請先選擇服務器哦',
        CloudList54: '支付成功',
        CloudManager1: '雲主機管理',
        CloudManager2: '雲主機列表',
        CloudManager3: '控製面板',
        CloudManager4: '控製臺',
        CloudManager5: '新工單',
        CloudManager6: '開機',
        CloudManager7: '關機',
        CloudManager8: '重啟',
        CloudManager9: '強製關機',
        CloudManager10: '強製重啟',
        CloudManager11: '續費',
        CloudManager12: '退款',
        CloudManager13: '創建中',
        CloudManager14: '運行中',
        CloudManager15: '關機',
        CloudManager16: '未知',
        CloudManager17: '等待重啟',
        CloudManager18: '等待狀態更新',
        CloudManager19: '暫停',
        CloudManager20: '掛起',
        CloudManager21: '正在',
        CloudManager22: '復製實例信息',
        CloudManager23: '業務狀態',
        CloudManager24: '正常',
        CloudManager25: '禁用',
        CloudManager26: '到期暫停',
        CloudManager27: '流量超額暫停',
        CloudManager28: '試用',
        CloudManager29: '已回收',
        CloudManager30: '數據中心',
        CloudManager31: '操作系統',
        CloudManager32: '開通時間',
        CloudManager33: '到期時間',
        CloudManager34: 'IP地址',
        CloudManager35: '重裝系統',
        CloudManager36: '續費',
        CloudManager37: '拷貝全部',
        CloudManager38: '遠程端口',
        CloudManager39: '實例用戶名',
        CloudManager40: '實例密碼',
        CloudManager41: '重置密碼',
        CloudManager42: '救援模式',
        CloudManager43: '未開啟',
        CloudManager44: '已開啟',
        CloudManager45: '密碼',
        CloudManager46: '進入救援系統',
        CloudManager47: '退出救援系統',
        CloudManager48: '備註',
        CloudManager49: '修改備註',
        CloudManager50: '流量概況',
        CloudManager51: 'CPU 使用率',
        CloudManager52: '概況',
        CloudManager53: '實例信息',
        CloudManager54: '復製配置信息',
        CloudManager55: '數據中心',
        CloudManager56: '到期時間',
        CloudManager57: '帶寬/流量信息',
        CloudManager58: '網絡類型',
        CloudManager59: '帶寬大小',
        CloudManager60: 'IP地址',
        CloudManager61: '遠程端口',
        CloudManager62: '配置信息',
        CloudManager63: '核',
        CloudManager64: '內存',
        CloudManager65: '系統盤',
        CloudManager66: '數據盤',
        CloudManager67: 'IP數',
        CloudManager68: '操作系統',
        CloudManager69: '計費信息',
        CloudManager70: '續費價格/月',
        CloudManager71: '續費價格/年',
        CloudManager72: '開通時間',
        CloudManager73: '到期時間',
        CloudManager74: '架構圖',
        CloudManager75: '監控',
        CloudManager76: 'CPU使用率',
        CloudManager77: '磁盤使用率',
        CloudManager78: '內存使用率',
        CloudManager79: '網卡使用率',
        CloudManager80: '包轉發率',
        CloudManager81: '網絡',
        CloudManager82: '帶寬/流量信息',
        CloudManager83: '上行帶寬',
        CloudManager84: '下行帶寬',
        CloudManager85: '月流量',
        CloudManager86: '網絡',
        CloudManager87: '掩碼',
        CloudManager88: '網關',
        CloudManager89: '安全組',
        CloudManager90: '創建時間',
        CloudManager91: '規則方向',
        CloudManager92: '入方向',
        CloudManager93: '出方向',
        CloudManager94: '授權類型',
        CloudManager95: '端口',
        CloudManager96: '授權IP',
        CloudManager97: '是否鎖定',
        CloudManager98: '不鎖定',
        CloudManager99: '鎖定',
        CloudManager100: '備註',
        CloudManager101: '操作',
        CloudManager104: '名稱',
        CloudManager105: '操作',
        CloudManager106: '新增',
        CloudManager107: '定時任務',
        CloudManager108: '創建任務',
        CloudManager109: '類型',
        CloudManager110: '快照',
        CloudManager111: '備份',
        CloudManager112: '頻率',
        CloudManager113: '小時',
        CloudManager114: '天',
        CloudManager115: '周',
        CloudManager116: '月',
        CloudManager117: '開始創建時間',
        CloudManager118: '磁盤',
        CloudManager119: '創建時間',
        CloudManager120: '操作',
        CloudManager121: '修改主機名',
        CloudManager122: '新主機名',
        CloudManager123: '修改備註',
        CloudManager124: '備註',
        CloudManager125: '重置實例密碼',
        CloudManager126: '新密碼',
        CloudManager127: '隨機生成',
        CloudManager128: '重裝系統',
        CloudManager129: '操作系統',
        CloudManager130: '密碼',
        CloudManager131: '隨機生成',
        CloudManager132: '端口',
        CloudManager133: '是否只格式化系統',
        CloudManager134: '服務器續費',
        CloudManager135: '服務器ID',
        CloudManager136: '主機名稱',
        CloudManager137: '開通時間',
        CloudManager138: '到期時間',
        CloudManager139: '續費時長',
        CloudManager140: '個月',
        CloudManager141: '支付方式',
        CloudManager142: '價格',
        CloudManager143: '續費',
        CloudManager144: '進入救援系統',
        CloudManager145: '救援系統類型',
        CloudManager146: '跟隨實例',
        CloudManager147: 'windows中文版',
        CloudManager148: 'windows英文版',
        CloudManager149: '救援系統密碼',
        CloudManager150: '隨機生成',
        CloudManager151: '新增安全組規則',
        CloudManager152: '規則方向',
        CloudManager153: '入方向',
        CloudManager154: '出方向',
        CloudManager155: '授權類型',
        CloudManager156: '端口',
        CloudManager157: '授權IP (0.0.0.0/0 不限製)',
        CloudManager158: '是否鎖定',
        CloudManager159: '不鎖定',
        CloudManager160: '鎖定',
        CloudManager161: '備註',
        CloudManager162: '創建定時任務',
        CloudManager163: '類型',
        CloudManager164: '定時快照',
        CloudManager165: '定時備份',
        CloudManager166: '磁盤選擇',
        CloudManager167: '系統盤 ',
        CloudManager168: '數據盤 ',
        CloudManager169: '開始創建時間',
        CloudManager170: '頻率',
        CloudManager171: '小時',
        CloudManager172: '天',
        CloudManager173: '周',
        CloudManager174: '月',
        CloudManager175: '註意：當可用備份/快照數量不足時，將自動覆蓋最老的那一條數據',
        CloudManager176: '雲服務器退款',
        CloudManager177: '服務器ID',
        CloudManager178: '主IP',
        CloudManager179: '服務器名稱',
        CloudManager180: '開通時間',
        CloudManager181: '到期時間',
        CloudManager182: '退款金額',
        CloudManager183: '預計退款金額',
        CloudManager184: '具體以財務實際退款為準',
        CloudManager185: '退款原因',
        CloudManager186: '退款',
        CloudManager187: 'CPU使用率',
        CloudManager188: '讀取速度',
        CloudManager189: '寫入速度',
        CloudManager190: '讀取',
        CloudManager191: '寫入',
        CloudManager192: '總量',
        CloudManager193: '已用',
        CloudManager194: '接收',
        CloudManager195: '發送',
        CloudManager196: '接收包',
        CloudManager197: '發送包',
        CloudManager198: '請先輸入新主機名喲',
        CloudManager199: '請先輸入新密碼喲',
        CloudManager200: '支付成功',
        CloudManager201: '請先輸入密碼喲',
        CloudManager202: '完成',
        CloudManager203: '請先選擇要查詢的時間喲',
        CloudManager204: '當前實例無可用快照數量哦',
        CloudManager205: '當前實例無可用備份數量哦',
        CloudManager206: '申請退款成功，可前往退款列表查看',
        CloudManager207: '提示',
        CloudManager208: '前往退款列表',
        DomainContacts1: '域名管理',
        DomainContacts2: '域名模板',
        DomainContacts3: '關鍵字',
        DomainContacts4: '郵箱',
        DomainContacts5: '電話',
        DomainContacts6: '狀態',
        DomainContacts7: '啟用',
        DomainContacts8: '禁用',
        DomainContacts9: '新建模板',
        DomainContacts10: '模板名稱',
        DomainContacts11: '創建時間',
        DomainContacts12: '郵箱',
        DomainContacts13: '電話',
        DomainContacts14: '狀態',
        DomainContacts15: '啟用',
        DomainContacts16: '禁用',
        DomainContacts17: '操作',
        DomainContacts18: '編輯',
        DomainContactsAdd1: '域名管理',
        DomainContactsAdd2: '域名模板',
        DomainContactsAdd3: '新建域名模板',
        DomainContactsAdd4: '填寫下面表格創建新的聯系人資料，添加新的聯系人不會改變已有域名的相關信息。',
        DomainContactsAdd5: '聯系人信息',
        DomainContactsAdd6: '模板名稱',
        DomainContactsAdd7: '公司名稱',
        DomainContactsAdd8: '名字',
        DomainContactsAdd9: '姓氏',
        DomainContactsAdd10: '國家/地區',
        DomainContactsAdd11: '州/省',
        DomainContactsAdd12: '城市',
        DomainContactsAdd13: '郵政編碼',
        DomainContactsAdd14: '郵箱',
        DomainContactsAdd15: '電話',
        DomainContactsAdd16: '聯系地址',
        DomainContactsAdd17: '狀態',
        DomainContactsAdd18: '啟用',
        DomainContactsAdd19: '禁用',
        DomainContactsAdd20: '保存模板',
        DomainContactsAdd21: '返回',
        DomainContactsAdd22: '新建模板',
        DomainContactsAdd23: '模板詳情',
        DomainDetails1: '域名管理',
        DomainDetails2: '域名列表',
        DomainDetails3: '域名解析',
        DomainDetails4: '添加解析',
        DomainDetails5: '主機名',
        DomainDetails6: '域名',
        DomainDetails7: '類型',
        DomainDetails8: '對應值',
        DomainDetails9: '優先級',
        DomainDetails10: '操作',
        DomainDetails11: 'DNS服務器',
        DomainDetails12: '編輯',
        DomainDetails13: '添加DNS服務器',
        DomainDetails14: '保存更改',
        DomainDetails15: '刪除',
        DomainDetails16: '子域名網址轉發',
        DomainDetails17: '添加網址轉發',
        DomainDetails18: '主機名',
        DomainDetails19: '創建時間',
        DomainDetails20: '目標地址',
        DomainDetails21: '類型',
        DomainDetails22: 'meta信息',
        DomainDetails23: 'meta標題',
        DomainDetails24: 'meta描述',
        DomainDetails25: 'meta關鍵字',
        DomainDetails26: '操作',
        DomainDetails27: '域名詳情',
        DomainDetails28: '域名續費',
        DomainDetails29: '域名退款',
        DomainDetails30: '域名信息',
        DomainDetails31: '域名',
        DomainDetails32: '狀態',
        DomainDetails33: '正常',
        DomainDetails34: '到期',
        DomainDetails35: '已刪除',
        DomainDetails36: '域名後綴',
        DomainDetails37: '註冊時間',
        DomainDetails38: '到期時間',
        DomainDetails39: '註冊價格/年',
        DomainDetails40: '續費價格/年',
        DomainDetails41: '域名聯系人',
        DomainDetails42: '公司名稱',
        DomainDetails43: '姓氏',
        DomainDetails44: '名字',
        DomainDetails45: '國家/地區',
        DomainDetails46: '州/省',
        DomainDetails47: '城市',
        DomainDetails48: '郵政編碼',
        DomainDetails49: '郵箱',
        DomainDetails50: '電話',
        DomainDetails51: '聯系地址',
        DomainDetails52: '域名續費',
        DomainDetails53: '域名',
        DomainDetails54: '註冊時間',
        DomainDetails55: '到期時間',
        DomainDetails56: '續費時長',
        DomainDetails57: '年',
        DomainDetails58: '支付方式',
        DomainDetails59: '年付',
        DomainDetails60: '總價',
        DomainDetails61: '續費',
        DomainDetails62: '域名退款',
        DomainDetails63: '域名',
        DomainDetails64: '註冊時間',
        DomainDetails65: '到期時間',
        DomainDetails66: '退款金額',
        DomainDetails67: '預計退款金額',
        DomainDetails68: '具體以財務實際退款為準',
        DomainDetails69: '退款原因',
        DomainDetails70: '退款',
        DomainDetails71: '添加解析',
        DomainDetails72: '修改解析',
        DomainDetails73: '主機名',
        DomainDetails74: '請輸入,為空則為根域名',
        DomainDetails75: '類型',
        DomainDetails76: '對應值',
        DomainDetails77: '優先級',
        DomainDetails78: '請輸入，如果未提供，則默認為 10',
        DomainDetails79: '添加網址轉發',
        DomainDetails80: '主機名',
        DomainDetails81: '目標地址',
        DomainDetails82: '轉發方法',
        DomainDetails83: 'META 標題',
        DomainDetails84: 'META 描述',
        DomainDetails85: 'META 關鍵字',
        DomainDetails86: '支付成功',
        DomainDetails87: '溫馨提示：初次註冊的網域預設的解析記錄請務必刪除掉，否則解析可能不會生效！',
        DomainDetails88: '主域名網址轉發',
        DomainDetails89: '當前域名已被註冊局停止解析，添加解析也不會生效，如有疑問，請聯系客服！',
        DomainList1: '域名管理',
        DomainList2: '域名列表',
        DomainList3: '去選購',
        DomainList4: '域名',
        DomainList5: '狀態',
        DomainList6: '正常',
        DomainList7: '到期',
        DomainList8: '已刪除',
        DomainList9: '時間查詢',
        DomainList10: '域名',
        DomainList11: '註冊時間',
        DomainList12: '到期時間',
        DomainList13: '狀態',
        DomainList14: '正常',
        DomainList15: '到期',
        DomainList16: '已刪除',
        DomainList17: '註冊價格/年',
        DomainList18: '操作',
        DomainList19: '管理',
        DomainList20: '續費',
        DomainList21: '域名續費',
        DomainList22: '域名',
        DomainList23: '註冊時間',
        DomainList24: '到期時間',
        DomainList25: '續費時長',
        DomainList26: '年',
        DomainList27: '支付方式',
        DomainList28: '年付',
        DomainList29: '總價',
        DomainList30: '續費',
        DomainList31: '域名退款',
        DomainList32: '域名',
        DomainList33: '註冊時間',
        DomainList34: '到期時間',
        DomainList35: '退款金額',
        DomainList36: '預計退款金額',
        DomainList37: '具體以財務實際退款為準',
        DomainList38: '退款原因',
        DomainList39: '退款',
        DomainList40: '支付成功',
        ServerList1: '物理機管理',
        ServerList2: '服務器列表',
        ServerList3: '去選購',
        ServerList4: '產品名稱',
        ServerList5: '狀態',
        ServerList6: '正常',
        ServerList7: '已到期',
        ServerList8: '試用',
        ServerList9: '時間查詢',
        ServerList10: '批量續費',
        ServerList11: '產品名稱',
        ServerList12: '主IP',
        ServerList13: '業務IP',
        ServerList14: '拷貝全部',
        ServerList15: '開通時間',
        ServerList16: '到期時間',
        ServerList17: '續費/月',
        ServerList18: '狀態',
        ServerList19: '正常',
        ServerList20: '已到期',
        ServerList21: '已退款',
        ServerList22: '試用',
        ServerList23: '備註',
        ServerList24: '操作',
        ServerList25: '面板',
        ServerList26: '續費',
        ServerList27: '服務器續費',
        ServerList28: '服務器ID',
        ServerList29: '主IP',
        ServerList30: '服務器名稱',
        ServerList31: '主IP',
        ServerList32: '續費價格',
        ServerList33: '續費時長',
        ServerList34: '個月',
        ServerList35: '支付方式',
        ServerList36: '價格',
        ServerList37: '修改備註',
        ServerList38: '備註',
        ServerList39: '請先選擇服務器哦',
        ServerList40: '支付成功',
        ServerList41: '待開通',
        ServerList42: '支付金額',
        ServerList43: '已回收',
        ServerManager1: '物理機管理',
        ServerManager2: '服務器列表',
        ServerManager3: '控製面板',
        ServerManager4: '取消重裝',
        ServerManager5: '控製面板',
        ServerManager6: '訂單列表',
        ServerManager7: '開機',
        ServerManager8: '關機',
        ServerManager9: '重啟',
        ServerManager10: '重裝系統',
        ServerManager11: '續費',
        ServerManager12: '退款',
        ServerManager13: '服務器信息',
        ServerManager14: '主IP',
        ServerManager15: '業務IP',
        ServerManager16: '拷貝全部',
        ServerManager17: '業務狀態',
        ServerManager18: '正常',
        ServerManager19: '已到期',
        ServerManager20: '已銷毀',
        ServerManager21: '試用',
        ServerManager22: '用戶名',
        ServerManager23: '密碼',
        ServerManager24: '端口',
        ServerManager25: '網關',
        ServerManager26: '子網掩碼',
        ServerManager27: '操作系統',
        ServerManager28: '備註',
        ServerManager29: '控製面板',
        ServerManager30: '產品名稱',
        ServerManager31: '開通時間',
        ServerManager32: '到期時間',
        ServerManager33: '續費價格/月',
        ServerManager34: '續費價格/年',
        ServerManager35: '服務器編號',
        ServerManager36: '配置信息',
        ServerManager37: '流量圖',
        ServerManager38: '最近12小時',
        ServerManager39: '最近1天',
        ServerManager40: '最近3天',
        ServerManager41: '最近7天',
        ServerManager42: '最近30天',
        ServerManager43: '全部',
        ServerManager44: '暫無流量圖信息喲',
        ServerManager45: '主訂單',
        ServerManager46: '裸機',
        ServerManager47: '硬盤',
        ServerManager48: '內存',
        ServerManager49: '防禦',
        ServerManager50: '流量',
        ServerManager51: '帶寬',
        ServerManager52: '其他',
        ServerManager53: '新開',
        ServerManager54: '續費',
        ServerManager55: '已支付',
        ServerManager56: '未支付',
        ServerManager57: '已退款',
        ServerManager58: '未生效',
        ServerManager59: '已生效',
        ServerManager60: '已取消',
        ServerManager61: '已退款',
        ServerManager62: '訂單ID',
        ServerManager63: '訂單號',
        ServerManager64: '訂單類型',
        ServerManager65: '新開',
        ServerManager66: '續費',
        ServerManager67: '創建時間',
        ServerManager68: '購買時長',
        ServerManager69: '試用',
        ServerManager70: '月',
        ServerManager71: '季度',
        ServerManager72: '半年',
        ServerManager73: '年',
        ServerManager74: '購買數量',
        ServerManager75: '實際支付價格',
        ServerManager76: '訂單描述',
        ServerManager77: '查看詳情',
        ServerManager78: '重裝系統',
        ServerManager79: '操作系統',
        ServerManager80: '密碼',
        ServerManager81: '隨機生成',
        ServerManager82: '端口',
        ServerManager83: '是否只格式化系統',
        ServerManager84: '服務器續費',
        ServerManager85: '服務器ID',
        ServerManager86: '主IP',
        ServerManager87: '服務器名稱',
        ServerManager88: '開通時間',
        ServerManager89: '到期時間',
        ServerManager90: '續費時長',
        ServerManager91: '個月',
        ServerManager92: '支付方式',
        ServerManager93: '價格',
        ServerManager94: '續費',
        ServerManager95: '重置密碼',
        ServerManager96: '新密碼',
        ServerManager97: '隨機生成',
        ServerManager98: '修改備註',
        ServerManager99: '備註',
        ServerManager100: '服務器退款',
        ServerManager101: '服務器ID',
        ServerManager102: '主IP',
        ServerManager103: '服務器名稱',
        ServerManager104: '開通時間',
        ServerManager105: '到期時間',
        ServerManager106: '退款金額',
        ServerManager107: '預計退款金額',
        ServerManager108: '具體以財務實際退款為準',
        ServerManager109: '退款原因',
        ServerManager110: '退款',
        ServerManager111: '操作系統重裝進度',
        ServerManager112: '請先選擇要查詢的時間喲',
        ServerManager113: '支付成功',
        ServerManager114: '待開通',
        ServerManager115: '內網IP',
        ServerManager116: '日誌記錄',
        ServerManager117: '創建時間',
        ServerManager118: '類型',
        ServerManager119: '操作IP',
        ServerManager120: '標題',
        ServerManager121: '詳情',
        ServerManager122: '查看',
        VpsList1: 'VPS管理',
        VpsList2: 'VPS列表',
        VpsList3: '去選購',
        VpsList4: '產品名稱',
        VpsList5: '狀態',
        VpsList6: '正常',
        VpsList7: '已到期',
        VpsList8: '試用',
        VpsList9: '時間查詢',
        VpsList10: '批量續費',
        VpsList11: '產品名稱',
        VpsList12: '主IP',
        VpsList13: '業務IP',
        VpsList14: '拷貝全部',
        VpsList15: '開通時間',
        VpsList16: '到期時間',
        VpsList17: '續費/月',
        VpsList18: '狀態',
        VpsList19: '正常',
        VpsList20: '已到期',
        VpsList21: '已退款',
        VpsList22: '試用',
        VpsList23: '備註',
        VpsList24: '操作',
        VpsList25: '面板',
        VpsList26: '續費',
        VpsList27: 'VPS續費',
        VpsList28: 'VPS ID',
        VpsList29: '主IP',
        VpsList30: 'VPS名稱',
        VpsList31: '主IP',
        VpsList32: '續費價格',
        VpsList33: '續費時長',
        VpsList34: '個月',
        VpsList35: '支付方式',
        VpsList36: '價格',
        VpsList37: '修改備註',
        VpsList38: '備註',
        VpsList39: '請先選擇VPS哦',
        VpsList40: '支付成功',
        VpsList41: '待開通',
        VpsList42: '支付金額',
        VpsList43: '已暫停',
        VpsList44: '關機',
        VpsManager1: 'VPS管理',
        VpsManager2: 'VPS列表',
        VpsManager3: '控製面板',
        VpsManager4: '控製臺',
        VpsManager5: '開機',
        VpsManager6: '關機',
        VpsManager7: '重啟',
        VpsManager8: '強製關機',
        VpsManager9: '強製重啟',
        VpsManager10: '續費',
        VpsManager11: '退款',
        VpsManager12: '已使用流量',
        VpsManager13: '流量總量',
        VpsManager14: '主IP',
        VpsManager15: '重置密碼',
        VpsManager16: '默認',
        VpsManager17: '重裝系統',
        VpsManager18: '修改備註',
        VpsManager19: '概況',
        VpsManager20: '配置信息',
        VpsManager21: '監控',
        VpsManager22: '帶寬使用率',
        VpsManager23: '內存使用量',
        VpsManager24: 'CPU使用率',
        VpsManager25: '硬盤使用率',
        SslContacts1: 'SSL管理',
        SslContacts2: 'SSL模板',
        SslContacts3: '模板名稱',
        SslContacts4: '新建模板',
        SslContacts5: '批量刪除',
        SslContacts6: '模板名稱',
        SslContacts7: '創建時間',
        SslContacts8: '姓名',
        SslContacts9: '郵箱',
        SslContacts10: '手機',
        SslContacts11: '操作',
        SslContacts12: '編輯',
        SslContacts13: '請先選擇模板哦',
        SslContactsAdd1: 'SSL管理',
        SslContactsAdd2: 'SSL模板',
        SslContactsAdd3: '新建SSL聯系人模板',
        SslContactsAdd4: '填寫下面表格創建新的聯系人資料，添加新的聯系人不會改變已有SSL的相關信息。',
        SslContactsAdd5: '模板信息',
        SslContactsAdd6: '模板名稱',
        SslContactsAdd7: '管理員信息',
        SslContactsAdd8: '名字',
        SslContactsAdd9: '姓氏',
        SslContactsAdd10: '郵箱',
        SslContactsAdd11: '手機號碼',
        SslContactsAdd12: '職業',
        SslContactsAdd13: '機構',
        SslContactsAdd14: '國家/地區',
        SslContactsAdd15: '州/省',
        SslContactsAdd16: '城市',
        SslContactsAdd17: '郵政編碼',
        SslContactsAdd18: '地址',
        SslContactsAdd19: '技術支持聯系信息',
        SslContactsAdd20: '與管理員信息相同',
        SslContactsAdd21: '當 SSL 證書類型是企業機構證書時，需要提供技術支持的聯系信息。',
        SslContactsAdd22: '財務聯系信息',
        SslContactsAdd23: '組織聯系信息',
        SslContactsAdd24: '機構',
        SslContactsAdd25: '手機號碼',
        SslContactsAdd26: '國家/地區',
        SslContactsAdd27: '城市',
        SslContactsAdd28: '郵政編碼',
        SslContactsAdd29: '地址',
        SslContactsAdd30: '保存模板',
        SslContactsAdd31: '返回',
        SslContactsAdd32: '新建模板',
        SslContactsAdd33: '請填寫模板名稱哦',
        SslContactsAdd34: '模板詳情',
        Ticket1: '工單',
        Ticket2: '工單列表',
        Ticket3: '標題',
        Ticket4: '標題',
        Ticket5: '創建時間',
        Ticket6: '產品類型',
        Ticket7: '狀態',
        Ticket8: '已開啟',
        Ticket9: '處理中',
        Ticket10: '用戶已回復',
        Ticket11: '工程師已回復',
        Ticket12: '已關閉',
        Ticket13: '已刪除',
        Ticket14: '工程師已讀',
        Ticket15: '未讀',
        Ticket16: '已讀',
        Ticket17: '操作',
        Ticket18: '查看詳情',
        Ticket19: '是否確定關閉工單',
        Ticket20: '關閉工單',
        TicketAdd1: '工單',
        TicketAdd2: '提交工單',
        TicketAdd3: '新建工單',
        TicketAdd4: '工單標題',
        TicketAdd5: '工單類型',
        TicketAdd6: '服務器',
        TicketAdd7: '域名',
        TicketAdd8: '雲服務器',
        TicketAdd9: 'SSL證書',
        TicketAdd10: '其他',
        TicketAdd11: '服務產品',
        TicketAdd12: '無數據',
        TicketAdd13: '工單內容',
        TicketAdd14: '提交工單',
        TicketAdd15: '請填寫工單標題哦',
        TicketAdd16: '請選擇工單類型哦',
        TicketAdd17: '請選擇服務產品哦',
        TicketAdd18: '請填寫工單內容哦',
        TicketAdd19: '工單分類',
        TicketAdd20: '請填寫工單分類哦',
        TicketDetails1: '工單',
        TicketDetails2: '工單列表',
        TicketDetails3: '工單詳情',
        TicketDetails4: '標題',
        TicketDetails5: '創建時間',
        TicketDetails6: '產品類型',
        TicketDetails7: '產品ID',
        TicketDetails8: '工單狀態',
        TicketDetails9: '已開啟',
        TicketDetails10: '處理中',
        TicketDetails11: '用戶已回復',
        TicketDetails12: '工程師已回復',
        TicketDetails13: '已關閉',
        TicketDetails14: '已刪除',
        TicketDetails15: '工程師已讀',
        TicketDetails16: '未讀',
        TicketDetails17: '已讀',
        TicketDetails18: '消息記錄',
        TicketDetails19: '用戶',
        TicketDetails20: '系統',
        TicketDetails21: '工程師',
        TicketDetails22: '財務',
        TicketDetails23: '用戶',
        TicketDetails24: '系統',
        TicketDetails25: '工程師',
        TicketDetails26: '財務',
        TicketDetails27: '消息回復',
        TicketDetails28: '回復',
        TicketDetails29: '請填寫要回復的內容哦',
        TicketDetails30: '資源信息',
        UserInfo1: '賬戶管理',
        UserInfo2: '賬戶信息',
        UserInfo3: '基本信息',
        UserInfo4: '賬戶ID',
        UserInfo5: '用戶名',
        UserInfo6: '最後登錄IP',
        UserInfo7: '最後登錄時間',
        UserInfo8: '登錄信息',
        UserInfo9: '郵箱',
        UserInfo10: '手機號',
        UserInfo11: '密碼',
        UserInfo12: '修改',
        UserInfo13: '個人信息',
        UserInfo14: '編輯',
        UserInfo15: '保存',
        UserInfo16: '姓氏',
        UserInfo17: '名字',
        UserInfo18: '公司名稱',
        UserInfo19: '地區',
        UserInfo20: '國家/地區',
        UserInfo21: '州/省',
        UserInfo22: '城市',
        UserInfo23: '聯系地址',
        UserInfo24: '郵政編碼',
        UserInfo25: '修改密碼',
        UserInfo26: '原密碼',
        UserInfo27: '新密碼',
        UserInfo28: '重復新密碼',
        UserInfo29: '確認更改',
        UserInfo30: '敏感操作驗證',
        UserInfo31: '穀歌驗證',
        UserInfo32: '已綁定',
        UserInfo33: '解除綁定',
        UserInfo34: '請掃描二維碼綁定',
        UserInfo35: '動態驗證碼',
        UserInfo36: '綁定',
        UserNotice1: '通知設置',
        UserNotice2: 'Telegram通知',
        UserNotice3: '如果您不知道您的電報ID是多少，您可以先關註我們的官方機器人',
        UserNotice4: '向機器人發送命令：獲取ID，他會將您的ID返回給您',
        UserNotice5: '郵件系統通知',
        UserNotice6: '保存更改',
        UserNotice7: '請先輸入Telegram ID哦',
        UserNotice8: '價格顯示通知',
        UserLoginLog1: '賬戶管理',
        UserLoginLog2: '登錄日誌',
        UserLoginLog3: 'IP地址',
        UserLoginLog4: '狀態',
        UserLoginLog5: '成功',
        UserLoginLog6: '失敗',
        UserLoginLog7: '時間查詢',
        UserLoginLog8: '操作信息',
        UserLoginLog9: '操作時間',
        UserLoginLog10: 'IP地址',
        UserLoginLog11: '狀態',
        UserLoginLog12: '成功',
        UserLoginLog13: '失敗',
        UserCoupons1: '帳戶管理',
        UserCoupons2: '優惠卷清單',
        UserCoupons3: '名稱',
        UserCoupons4: '消費門檻',
        UserCoupons5: '優惠卷金額',
        UserCoupons6: '折扣',
        UserCoupons7: '有效天數',
        UserCoupons8: '類型',
        UserCoupons9: '滿减卷',
        UserCoupons10: '折扣券',
        UserCoupons11: '代金券',
        UserCoupons12: '狀態',
        UserCoupons13: '未使用',
        UserCoupons14: '已使用',
        UserCoupons15: '使用場景',
        UserCoupons16: '通用',
        UserCoupons17: '物理機',
        UserCoupons18: '雲服務器',
        UserCoupons19: '域名',
        UserCoupons20: '到期時間',
        UserCoupons21: '是否到期',
        UserCoupons22: '已到期',
        UserCoupons23: '未到期',
        UserCoupons24: '領取時間',
        BalanceBill1: '訂單管理',
        BalanceBill2: '訂單列表',
        BalanceBill3: '訂單編號',
        BalanceBill4: '創建時間',
        BalanceBill5: '支付訂單編號',
        BalanceBill6: '創建時間',
        BalanceBill7: '訂單金額',
        BalanceBill8: '實際支付金額',
        BalanceBill9: '支付方式',
        BalanceBill10: '支付狀態',
        BalanceBill11: '支付成功',
        BalanceBill12: '未支付',
        BalanceBill13: '已退款',
        BalanceBill14: '操作',
        BalanceBill15: '部分退款',
        BalanceBill16: '交易過期',
        BalanceBillDetails1: '用戶中心',
        BalanceBillDetails2: '訂單管理',
        BalanceBillDetails3: '訂單列表',
        BalanceBillDetails4: '訂單詳情',
        BalanceBillDetails5: '訂單編號',
        BalanceBillDetails6: '打印',
        BalanceBillDetails7: '下載',
        BalanceBillDetails8: '訂單類型',
        BalanceBillDetails9: '創建時間',
        BalanceBillDetails10: '未支付',
        BalanceBillDetails11: '支付成功',
        BalanceBillDetails12: '已退款',
        BalanceBillDetails13: '支付給',
        BalanceBillDetails14: '開票給',
        BalanceBillDetails15: '賬單項目',
        BalanceBillDetails16: '描述',
        BalanceBillDetails17: '訂單狀態',
        BalanceBillDetails18: '管理',
        BalanceBillDetails19: '金額',
        BalanceBillDetails20: '已支付',
        BalanceBillDetails21: '未支付',
        BalanceBillDetails22: '已退款',
        BalanceBillDetails23: '發起支付金額',
        BalanceBillDetails24: '已支付金額',
        BalanceBillDetails25: '賬單金額',
        BalanceBillDetails26: '退款金額',
        BalanceBillDetails27: '支付方式',
        BalanceBillDetails28: '立即支付',
        BalanceBillDetails29: '支付方式',
        BalanceBillDetails30: '支付成功',
        BalanceBillDetails31: '物理服務器',
        BalanceBillDetails32: '雲服務器',
        BalanceBillDetails33: 'ssl證書',
        BalanceBillDetails34: '域名',
        BalanceBillDetails35: '余額充值',
        BalanceBillDetails36: '充值成功',
        BalanceBillDetails37: '未支付',
        BalanceBillDetails38: '未到賬',
        BalanceBillDetails39: '未付款 信用額',
        BalanceBillDetails40: '支付失敗',
        BalanceBillDetails41: '優惠卷抵扣',
        SslList1: 'SSL管理',
        SslList2: 'SSL列表',
        SslList3: '去選購',
        SslList4: '產品名稱',
        SslList5: '域名',
        SslList6: '證書單號/CA/實例號',
        SslList7: '支付訂單號',
        SslList8: '時間查詢',
        SslList9: '解析主機',
        SslList10: '解析方式',
        SslList11: '解析值',
        SslList12: '產品名稱',
        SslList13: '主域名',
        SslList14: 'CA訂單號',
        SslList15: '實例號',
        SslList16: '購買時間',
        SslList17: '狀態',
        SslList18: '已取消',
        SslList19: '申請成功',
        SslList20: '申請中',
        SslList21: '已到期',
        SslList22: '已重簽',
        SslList23: '申請失敗',
        SslList24: '已續費',
        SslList25: '已吊銷',
        SslList26: '退款',
        SslList27: '待提交',
        SslList28: '簽發狀態',
        SslList29: '未完成',
        SslList30: '已完成',
        SslList31: '驗證中',
        SslList32: '驗證狀態',
        SslList33: '未完成',
        SslList34: '已完成',
        SslList35: '驗證中',
        SslList36: '操作',
        SslList37: '管理證書',
        SslList38: '域名驗證',
        SslList39: 'SSL證書信息',
        SslList40: '通道',
        SslList41: '證書品牌',
        SslList42: '證書類型',
        SslList43: '域名類型',
        SslList44: '單域名',
        SslList45: '多域名',
        SslList46: '通配符',
        SslList47: '域名數量',
        SslList48: '單域名驗證',
        SslList49: '多域名驗證',
        SslList50: '請填寫主域名，無需填寫 * 號。如 example.com 覆蓋所有 *.example.com 域名，a.example.com 覆蓋所有 *.a.example.com 域名。',
        SslList51: '通配符驗證',
        SslList52: '域名',
        SslList53: '驗證規則',
        SslList54: '增加域名',
        SslList55: '聯系信息',
        SslList56: '新建模板',
        SslList57: '還沒有創建信息模板喲',
        SslList58: '姓名',
        SslList59: '郵箱',
        SslList60: '手機',
        SslList61: '提交申請',
        SslList62: 'DNS驗證',
        SslList63: 'http文件驗證',
        SslList64: 'https文件驗證',
        SslList65: '郵箱驗證',
        SslList66: '請先完整填寫域名信息和驗證規則哦',
    },
    // 英文
    'en': {
        common1: 'No data found~',
        common2: 'Cancel',
        common3: 'Close',
        common4: 'Please enter',
        common5: 'Sure',
        common6: 'User center',
        common7: 'Please select',
        common8: 'Please improve the form content first',
        common9: 'Start time',
        common10: 'End time',
        common11: 'Query',
        common12: 'Reset',
        common13: 'Are you sure to delete',
        common14: 'Delete',
        common15: 'The order information was not found',
        tools1: 'The text has been copied to the clipboard',
        tools2: 'Copy to clipboard failed',
        Home1: 'User ID',
        Home2: 'Last login time',
        Home3: 'Last login IP',
        Home4: 'Account balance',
        Home5: 'Recharge now',
        Home6: 'Balance details',
        Home7: 'Coupon',
        Home8: 'View',
        Home9: 'Work order processing',
        Home10: 'Account manager',
        Home11: 'After-sales customer service',
        Home12: 'Channel manager',
        Home13: 'Help center',
        Home14: 'Exclusive customer service',
        Home15: 'Online consultation',
        Home16: 'Submit work order',
        Home17: 'Recent data',
        Home18: 'Valid server',
        Home19: 'Valid domain name',
        Home20: 'Physical machine expiring within 7 days',
        Home21: 'VPS expires within 7 days',
        Home22: 'Cloud server expires within 7 days',
        Home23: 'Announcement',
        Home24: 'Notification',
        Home25: 'Product Service',
        Home26: 'Domain Name',
        Home27: 'Physical Machine',
        Home28: 'SSL Certificate',
        Home29: 'Cloud Server',
        Home30: 'Help Document',
        Home31: 'Document',
        Home32: 'There is currently no contact information available',
        LayOut1: 'Console',
        LayOut2: 'User center',
        LayOut3: 'Domain management',
        LayOut4: 'Domain list',
        LayOut5: 'Domain template',
        LayOut6: 'Physical server management',
        LayOut7: 'Physical server list',
        LayOut8: 'Cloud server management',
        LayOut9: 'Cloud server list',
        LayOut10: 'Vps management',
        LayOut11: 'Ssl management',
        LayOut12: 'Ssl list',
        LayOut13: 'Ssl template',
        LayOut14: 'Account management',
        LayOut15: 'Account information',
        LayOut16: 'Login log',
        LayOut17: 'Notification settings',
        LayOut18: 'Order management',
        LayOut19: 'Physical server order',
        LayOut20: 'Cloud server order',
        LayOut21: 'Domain name order',
        LayOut22: 'Ssl order',
        LayOut23: 'Work order',
        LayOut24: 'Work order list',
        LayOut25: 'Submit work order',
        LayOut26: 'Financial management',
        LayOut27: 'Online recharge',
        LayOut28: 'Balance details',
        LayOut29: 'Bill list',
        LayOut30: 'Refund list',
        LayOut31: 'Promotion plan',
        LayOut32: 'Official website',
        LayOut33: 'Work order',
        LayOut34: 'Account info',
        LayOut35: 'Bill list',
        LayOut36: 'Log out',
        LayOut37: 'Code scanning payment',
        LayOut38: 'Transaction number',
        LayOut39: 'The current usdt payment block network protocol is trc20',
        LayOut40: 'Click copy',
        LayOut41: 'Please complete the payment before the end of the countdown!',
        LayOut42: 'Google authentication binding',
        LayOut43: 'Please scan the QR code below to finish binding',
        LayOut44: 'User operation authentication',
        LayOut45: 'Authentication method',
        LayOut46: 'Google verification',
        LayOut47: 'Mailbox validation',
        LayOut48: 'Verification code',
        LayOut49: 'Get verification code',
        LayOut50: 'Not bound',
        LayOut51: 'Debinding',
        LayOut52: 'Last day',
        LayOut53: 'The last three days',
        LayOut54: 'Last week',
        LayOut55: 'Last month',
        LayOut56: 'Last three months',
        LayOut57: 'Last half year',
        LayOut58: 'Last year',
        LayOut59: 'Payment succeeded',
        LayOut60: 'Please fill in the verification code first',
        LayOut61: 'Order list',
        LayOut62: 'VPS list',
        LayOut63: 'The received amount needs to match the shown below',
        LayOut64: ' Consistent amount',
        LayOut65: ' ,Otherwise, it will not be credited to the account',
        Aff1: 'Referral program',
        Aff2: 'No promotional link yet',
        Aff3: 'Generate link',
        Aff4: 'Promotion link',
        Aff5: 'Promotion data',
        Aff6: 'Total commission',
        Aff7: 'Withdrawable amount',
        Aff8: 'Amount in process',
        Aff9: 'Invalid commission',
        Aff10: 'Click count',
        Aff11: 'Registered user',
        Aff12: 'Immediate withdrawal',
        Aff13: 'Promotion order',
        Aff14: 'Creation time',
        Aff15: 'Commission',
        Aff16: 'Order type',
        Aff17: 'New purchase',
        Aff18: 'Renewal',
        Aff19: 'Second order',
        Aff20: 'Order type',
        Aff21: 'Status',
        Aff22: 'Confirmed',
        Aff23: 'to be confirmed',
        Aff24: 'Invalid',
        Aff25: 'Withdrawal record',
        Aff26: 'Creation time',
        Aff27: 'Withdrawal commission',
        Aff28: 'Amount of commission actually paid',
        Aff29: 'Withdrawal Type',
        Aff30: 'Status',
        Aff31: 'Approved',
        Aff32: 'Audit failed',
        Aff33: 'Pending review',
        Aff34: 'Registered user',
        Aff35: 'Creation time',
        Aff36: 'User name',
        Aff37: 'Mailbox',
        Aff38: 'Telephone',
        Aff39: 'Last login time',
        Aff40: 'Promotion withdrawal',
        Aff41: 'Withdrawal method',
        Aff42: 'Account balance',
        Aff43: 'Bank card',
        Aff44: 'Alipay',
        Aff45: 'USDT',
        Aff46: 'WeChat',
        Aff47: 'Account number',
        Aff48: 'You can use Alipay account or bank card number to transfer money, TRC20 wallet address',
        Aff49: 'Name',
        Aff50: 'If it is a bank card transfer, the bank card and the name must be the same',
        Aff51: 'Withdrawal amount',
        Aff52: 'Withdrawable amount',
        BalanceDetails1: 'Financial management',
        BalanceDetails2: 'Balance details',
        BalanceDetails3: 'Description',
        BalanceDetails4: 'Order type',
        BalanceDetails5: 'Domain name',
        BalanceDetails6: 'Ssl certificate',
        BalanceDetails7: 'Physical server',
        BalanceDetails8: 'Cloud server',
        BalanceDetails9: 'Value added services',
        BalanceDetails10: 'Vpn private line',
        BalanceDetails11: 'Recharge',
        BalanceDetails12: 'Deduction',
        BalanceDetails13: 'Other products',
        BalanceDetails14: 'Creation time',
        BalanceDetails15: 'Creation time',
        BalanceDetails16: 'Balance before transaction',
        BalanceDetails17: 'Post transaction balance',
        BalanceDetails18: 'Balance change',
        BalanceDetails19: 'Type',
        BalanceDetails20: 'Description',
        BalanceDetails21: 'View details',
        BalanceDetails22: 'Detailed description',
        BalanceDetails23: 'Item description',
        BalanceDetails24: 'Project amount',
        BalanceRecharge1: 'Financial management',
        BalanceRecharge2: 'Online recharge',
        BalanceRecharge3: 'Online recharge',
        BalanceRecharge4: 'Current balance',
        BalanceRecharge5: 'Recharge amount',
        BalanceRecharge6: 'Payment method',
        BalanceRecharge7: 'Submit order',
        BalanceRecharge8: 'Please enter the amount to recharge first',
        BalanceRefund1: 'Financial management',
        BalanceRefund2: 'Refund list',
        BalanceRefund3: 'Status',
        BalanceRefund4: 'Pending',
        BalanceRefund5: 'Processed',
        BalanceRefund6: 'Rejected',
        BalanceRefund7: 'Canceled',
        BalanceRefund8: 'Deleted',
        BalanceRefund9: 'Creation time',
        BalanceRefund10: 'Creation time',
        BalanceRefund11: 'Apply for refund amount',
        BalanceRefund12: 'Status',
        BalanceRefund13: 'Pending',
        BalanceRefund14: 'Processed',
        BalanceRefund15: 'Rejected',
        BalanceRefund16: 'Canceled',
        BalanceRefund17: 'Deleted',
        BalanceRefund18: 'Resource type',
        BalanceRefund19: 'Virtual machine',
        BalanceRefund20: 'Refund reason',
        BalanceRefund21: 'Operation',
        BalanceRefund22: 'View details',
        BalanceRefund23: 'Physical machine',
        BalanceRefund24: 'Domain name',
        BalanceRefund25: 'SSL certificate',
        BalanceRefund26: 'Resource id',
        BalanceRefund27: 'Resource info',
        BalanceRefundDetails1: 'Financial management',
        BalanceRefundDetails2: 'Refund list',
        BalanceRefundDetails3: 'Refund details',
        BalanceRefundDetails4: 'Refund information',
        BalanceRefundDetails5: 'Status',
        BalanceRefundDetails6: 'Pending',
        BalanceRefundDetails7: 'Processed',
        BalanceRefundDetails8: 'Rejected',
        BalanceRefundDetails9: 'Canceled',
        BalanceRefundDetails10: 'Deleted',
        BalanceRefundDetails11: 'Cancel refund',
        BalanceRefundDetails12: 'Creation time',
        BalanceRefundDetails13: 'Apply for refund amount',
        BalanceRefundDetails14: 'Actual refund amount',
        BalanceRefundDetails15: 'Refund method',
        BalanceRefundDetails16: 'Balance',
        BalanceRefundDetails17: 'Return to the original route',
        BalanceRefundDetails18: 'Others',
        BalanceRefundDetails19: 'Resource type',
        BalanceRefundDetails20: 'Virtual machine',
        BalanceRefundDetails21: 'Resource id',
        BalanceRefundDetails22: 'Refund reason',
        BalanceRefundDetails23: 'Processing time',
        BalanceRefundDetails24: 'Processing notes',
        BalanceRefundDetails25: 'The refund information was not found',
        CloudList1: 'Virtual machine management',
        CloudList2: 'Virtual machine list',
        CloudList3: 'Go shopping',
        CloudList4: 'Host name',
        CloudList5: 'Business status',
        CloudList6: 'Normal',
        CloudList7: 'Disabled',
        CloudList8: 'Expiration suspension',
        CloudList9: 'Trial',
        CloudList10: 'Recycled',
        CloudList11: 'Time query',
        CloudList12: 'Batch renewal',
        CloudList13: 'Host name',
        CloudList14: 'Data center',
        CloudList15: 'Opening time',
        CloudList16: 'Expiration time',
        CloudList17: 'Renewal/month',
        CloudList18: 'Business status',
        CloudList19: 'Normal',
        CloudList20: 'Disabled',
        CloudList21: 'Expiration suspension',
        CloudList22: 'Excess traffic suspended',
        CloudList23: 'Trial',
        CloudList24: 'Recycled',
        CloudList25: 'Instance status',
        CloudList26: 'Creating',
        CloudList27: 'Running',
        CloudList28: 'Shutdown',
        CloudList29: 'Unknown',
        CloudList30: 'Wait for restart',
        CloudList31: 'Waiting for status update',
        CloudList32: 'Pause',
        CloudList33: 'Pending',
        CloudList34: 'Remarks',
        CloudList35: 'Operation',
        CloudList36: 'Panel',
        CloudList37: 'Renewal',
        CloudList38: 'Server renewal',
        CloudList39: 'Server id',
        CloudList40: 'Host name',
        CloudList41: 'Opening time',
        CloudList42: 'Expiration time',
        CloudList43: 'Opening time',
        CloudList44: 'Expiration time',
        CloudList45: 'Renewal price',
        CloudList46: 'Renewal duration',
        CloudList47: 'Months',
        CloudList48: 'Payment method',
        CloudList49: 'Price',
        CloudList50: 'Renewal',
        CloudList51: 'Modify remarks',
        CloudList52: 'Remarks',
        CloudList53: 'Please select a server first',
        CloudList54: 'Payment succeeded',
        CloudManager1: 'Virtual machine management',
        CloudManager2: 'Virtual machine list',
        CloudManager3: 'Control panel',
        CloudManager4: 'Console',
        CloudManager5: 'New work order',
        CloudManager6: 'Power on',
        CloudManager7: 'Shutdown',
        CloudManager8: 'Restart',
        CloudManager9: 'Forced shutdown',
        CloudManager10: 'Forced restart',
        CloudManager11: 'Renewal',
        CloudManager12: 'Refund',
        CloudManager13: 'Creating',
        CloudManager14: 'Running',
        CloudManager15: 'Shutdown',
        CloudManager16: 'Unknown',
        CloudManager17: 'Wait for restart',
        CloudManager18: 'Waiting for status update',
        CloudManager19: 'Pause',
        CloudManager20: 'Pending',
        CloudManager21: 'In progress',
        CloudManager22: 'Copy instance information',
        CloudManager23: 'Business status',
        CloudManager24: 'Normal',
        CloudManager25: 'Disabled',
        CloudManager26: 'Expiration suspension',
        CloudManager27: 'Excess traffic suspended',
        CloudManager28: 'Trial',
        CloudManager29: 'Recycled',
        CloudManager30: 'Data center',
        CloudManager31: 'Operating system',
        CloudManager32: 'Opening time',
        CloudManager33: 'Expiration time',
        CloudManager34: 'Ip address',
        CloudManager35: 'Reinstall the system',
        CloudManager36: 'Renewal',
        CloudManager37: 'Copy all',
        CloudManager38: 'Remote port',
        CloudManager39: 'Instance user name',
        CloudManager40: 'Instance password',
        CloudManager41: 'Reset password',
        CloudManager42: 'Rescue mode',
        CloudManager43: 'Not turned on',
        CloudManager44: 'Turned on',
        CloudManager45: 'Password',
        CloudManager46: 'Enter the rescue system',
        CloudManager47: 'Exit the rescue system',
        CloudManager48: 'Remarks',
        CloudManager49: 'Modify remarks',
        CloudManager50: 'Flow overview',
        CloudManager51: 'Cpu utilization',
        CloudManager52: 'Overview',
        CloudManager53: 'Instance information',
        CloudManager54: 'Copy configuration information',
        CloudManager55: 'Data center',
        CloudManager56: 'Expiration time',
        CloudManager57: 'Bandwidth/traffic information',
        CloudManager58: 'Network type',
        CloudManager59: 'Bandwidth size',
        CloudManager60: 'Ip address',
        CloudManager61: 'Remote port',
        CloudManager62: 'Configuration information',
        CloudManager63: 'Core',
        CloudManager64: 'Memory',
        CloudManager65: 'System disk',
        CloudManager66: 'Data disk',
        CloudManager67: 'Ip number',
        CloudManager68: 'Operating system',
        CloudManager69: 'Billing information',
        CloudManager70: 'Renewal price/month',
        CloudManager71: 'Renewal price/year',
        CloudManager72: 'Opening time',
        CloudManager73: 'Expiration time',
        CloudManager74: 'Architecture diagram',
        CloudManager75: 'Monitoring',
        CloudManager76: 'Cpu utilization',
        CloudManager77: 'Disk usage',
        CloudManager78: 'Memory usage',
        CloudManager79: 'Network card usage',
        CloudManager80: 'Packet forwarding rate',
        CloudManager81: 'Network',
        CloudManager82: 'Bandwidth/traffic information',
        CloudManager83: 'Uplink bandwidth',
        CloudManager84: 'Downlink bandwidth',
        CloudManager85: 'Monthly flow',
        CloudManager86: 'Network',
        CloudManager87: 'Mask',
        CloudManager88: 'Gateway',
        CloudManager89: 'Security Group',
        CloudManager90: 'Creation time',
        CloudManager91: 'Rule direction',
        CloudManager92: 'Incoming direction',
        CloudManager93: 'Outgoing direction',
        CloudManager94: 'Authorization type',
        CloudManager95: 'Port',
        CloudManager96: 'Authorized ip',
        CloudManager97: 'Whether to lock',
        CloudManager98: 'Do not lock',
        CloudManager99: 'Lock',
        CloudManager100: 'Remarks',
        CloudManager101: 'Operation',
        CloudManager104: 'Name',
        CloudManager105: 'Operation',
        CloudManager106: 'New',
        CloudManager107: 'Scheduled task',
        CloudManager108: 'Create task',
        CloudManager109: 'Type',
        CloudManager110: 'Snapshot',
        CloudManager111: 'Backup',
        CloudManager112: 'Frequency',
        CloudManager113: 'Hours',
        CloudManager114: 'Days',
        CloudManager115: 'Week ',
        CloudManager116: 'Month',
        CloudManager117: 'Start creation time',
        CloudManager118: 'Disk',
        CloudManager119: 'Creation time',
        CloudManager120: 'Operation',
        CloudManager121: 'Modify hostname',
        CloudManager122: 'New hostname',
        CloudManager123: 'Modify remarks',
        CloudManager124: 'Remarks',
        CloudManager125: 'Reset instance password',
        CloudManager126: 'New password',
        CloudManager127: 'Randomly generated',
        CloudManager128: 'Reinstall the system',
        CloudManager129: 'Operating system',
        CloudManager130: 'Password',
        CloudManager131: 'Randomly generated',
        CloudManager132: 'Port',
        CloudManager133: 'Format system only',
        CloudManager134: 'Server renewal',
        CloudManager135: 'Server id',
        CloudManager136: 'Host name',
        CloudManager137: 'Opening time',
        CloudManager138: 'Expiration time',
        CloudManager139: 'Renewal duration',
        CloudManager140: 'Months',
        CloudManager141: 'Payment method ',
        CloudManager142: 'Price ',
        CloudManager143: 'Renewal',
        CloudManager144: 'Enter the rescue system',
        CloudManager145: 'Rescue system type',
        CloudManager146: 'Follow instance',
        CloudManager147: 'Windows Chinese version',
        CloudManager148: 'Windows English ',
        CloudManager149: 'Rescue system password',
        CloudManager150: 'Randomly generated',
        CloudManager151: 'New security group rule',
        CloudManager152: 'Rule direction',
        CloudManager153: 'Incoming direction',
        CloudManager154: 'Outgoing direction',
        CloudManager155: 'Authorization type',
        CloudManager156: 'Port',
        CloudManager157: 'Authorized IP (0.0.0.0/0 unlimited)',
        CloudManager158: 'Whether to lock',
        CloudManager159: 'Do not lock',
        CloudManager160: 'Lock',
        CloudManager161: 'Remarks',
        CloudManager162: 'Create scheduled task',
        CloudManager163: 'Type',
        CloudManager164: 'Scheduled snapshot',
        CloudManager165: 'Scheduled backup',
        CloudManager166: 'Disk selection',
        CloudManager167: 'System disk',
        CloudManager168: 'Data disk',
        CloudManager169: 'Start creation time',
        CloudManager170: 'Frequency',
        CloudManager171: 'Hours',
        CloudManager172: 'Days',
        CloudManager173: 'Week',
        CloudManager174: 'Month',
        CloudManager175: 'Note: when the number of available backups/snapshots is insufficient, the oldest piece of data will be automatically overwritten',
        CloudManager176: 'ECS refund',
        CloudManager177: 'Server id',
        CloudManager178: 'Primary ip',
        CloudManager179: 'Server name',
        CloudManager180: 'Opening time',
        CloudManager181: 'Expiration time',
        CloudManager182: 'Refund amount',
        CloudManager183: 'Estimated refund amount',
        CloudManager184: 'The details shall be subject to the actual financial refund',
        CloudManager185: 'Refund reason',
        CloudManager186: 'Refund',
        CloudManager187: 'Cpu utilization',
        CloudManager188: 'Read speed',
        CloudManager189: 'Write speed',
        CloudManager190: 'Read',
        CloudManager191: 'Write',
        CloudManager192: 'Total',
        CloudManager193: 'Used',
        CloudManager194: 'Receive',
        CloudManager195: 'Send',
        CloudManager196: 'Receive packet',
        CloudManager197: 'Send package',
        CloudManager198: 'Please enter a new host name first',
        CloudManager199: 'Please enter the new password first',
        CloudManager200: 'Payment succeeded',
        CloudManager201: 'Please enter the password first',
        CloudManager202: 'Complete',
        CloudManager203: 'Please select the time to query first',
        CloudManager204: 'There are no available snapshots for the current instance',
        CloudManager205: 'There are no available backups for the current instance',
        CloudManager206: 'Apply for refund successfully, you can go to the refund list to view',
        CloudManager207: 'Prompt ',
        CloudManager208: 'Go to the refund list',
        DomainContacts1: 'Domain name management',
        DomainContacts2: 'Domain name template',
        DomainContacts3: 'Keyword',
        DomainContacts4: 'Mailbox',
        DomainContacts5: 'Telephone',
        DomainContacts6: 'Status',
        DomainContacts7: 'Enable',
        DomainContacts8: 'Disabled',
        DomainContacts9: 'New template',
        DomainContacts10: 'Template name',
        DomainContacts11: 'Creation time',
        DomainContacts12: 'Mailbox',
        DomainContacts13: 'Telephone',
        DomainContacts14: 'Status',
        DomainContacts15: 'Enable',
        DomainContacts16: 'Disabled',
        DomainContacts17: 'Operation',
        DomainContacts18: 'Edit',
        DomainContactsAdd1: 'Domain name management',
        DomainContactsAdd2: 'Domain name template',
        DomainContactsAdd3: 'New domain name template',
        DomainContactsAdd4: 'Fill in the form below to create a new contact information. Adding a new contact will not change the relevant information of the existing domain name.',
        DomainContactsAdd5: 'Contact information',
        DomainContactsAdd6: 'Template name',
        DomainContactsAdd7: 'Company name',
        DomainContactsAdd8: 'First name',
        DomainContactsAdd9: 'Last name',
        DomainContactsAdd10: 'Country/Area',
        DomainContactsAdd11: 'State/Province',
        DomainContactsAdd12: 'City',
        DomainContactsAdd13: 'Postal code',
        DomainContactsAdd14: 'Mailbox',
        DomainContactsAdd15: 'Telephone',
        DomainContactsAdd16: 'Contact address',
        DomainContactsAdd17: 'Status',
        DomainContactsAdd18: 'Enable',
        DomainContactsAdd19: 'Disabled',
        DomainContactsAdd20: 'Save template',
        DomainContactsAdd21: 'Return',
        DomainContactsAdd22: 'New template',
        DomainContactsAdd23: 'Template details',
        DomainDetails1: 'Domain name management',
        DomainDetails2: 'Domain name list',
        DomainDetails3: 'Domain name resolution',
        DomainDetails4: 'Add resolution',
        DomainDetails5: 'Hostname',
        DomainDetails6: 'Domain name',
        DomainDetails7: 'Type',
        DomainDetails8: 'Corresponding value',
        DomainDetails9: 'Priority',
        DomainDetails10: 'Operation',
        DomainDetails11: 'Dns server',
        DomainDetails12: 'Edit',
        DomainDetails13: 'Add DNS server',
        DomainDetails14: 'Save changes',
        DomainDetails15: 'Delete',
        DomainDetails16: 'Subdomain URL forwarding',
        DomainDetails17: 'Add URL forwarding',
        DomainDetails18: 'Hostname',
        DomainDetails19: 'Creation time',
        DomainDetails20: 'Destination address',
        DomainDetails21: 'Type',
        DomainDetails22: 'Meta information',
        DomainDetails23: 'Meta header',
        DomainDetails24: 'Meta description',
        DomainDetails25: 'Meta keyword',
        DomainDetails26: 'Operation',
        DomainDetails27: 'Domain name details',
        DomainDetails28: 'Domain name renewal',
        DomainDetails29: 'Domain name refund',
        DomainDetails30: 'Domain name information',
        DomainDetails31: 'Domain name',
        DomainDetails32: 'Status',
        DomainDetails33: 'Normal',
        DomainDetails34: 'Due',
        DomainDetails35: 'Deleted',
        DomainDetails36: 'Domain name suffix',
        DomainDetails37: 'Registration time',
        DomainDetails38: 'Expiration time',
        DomainDetails39: 'Registration price/year',
        DomainDetails40: 'Renewal price/year',
        DomainDetails41: 'Domain name contact',
        DomainDetails42: 'Company name',
        DomainDetails43: 'Last name',
        DomainDetails44: 'First name',
        DomainDetails45: 'Country/Area ',
        DomainDetails46: 'State/Province',
        DomainDetails47: 'City ',
        DomainDetails48: 'Postal code',
        DomainDetails49: 'Mailbox',
        DomainDetails50: 'Telephone ',
        DomainDetails51: 'Contact address',
        DomainDetails52: 'Domain name renewal',
        DomainDetails53: 'Domain name',
        DomainDetails54: 'Registration time',
        DomainDetails55: 'Expiration time',
        DomainDetails56: 'Renewal duration',
        DomainDetails57: 'Year',
        DomainDetails58: 'Payment method',
        DomainDetails59: 'Annual payment',
        DomainDetails60: 'Total price',
        DomainDetails61: 'Renewal',
        DomainDetails62: 'Domain name refund',
        DomainDetails63: 'Domain name',
        DomainDetails64: 'Registration time',
        DomainDetails65: 'Expiration time',
        DomainDetails66: 'Refund amount',
        DomainDetails67: 'Estimated refund amount',
        DomainDetails68: 'The details shall be subject to the actual financial refund',
        DomainDetails69: 'Refund reason',
        DomainDetails70: 'Refund',
        DomainDetails71: 'Add resolution',
        DomainDetails72: 'Modify resolution',
        DomainDetails73: 'Hostname',
        DomainDetails74: 'Please enter. If it is blank, it will be the root domain name',
        DomainDetails75: 'Type',
        DomainDetails76: 'Corresponding value',
        DomainDetails77: 'Priority',
        DomainDetails78: 'Please enter, if not provided, the default is 10',
        DomainDetails79: 'Add URL forwarding',
        DomainDetails80: 'Hostname',
        DomainDetails81: 'Destination address',
        DomainDetails82: 'Forwarding method',
        DomainDetails83: 'Meta title',
        DomainDetails84: 'Meta description',
        DomainDetails85: 'Meta keyword',
        DomainDetails86: 'Payment succeeded',
        DomainDetails87: 'Tips: Please be sure to delete the default resolution record of the domain name you registered for the first time, otherwise the resolution may not take effect!',
        DomainDetails88: 'Main domain URL forwarding',
        DomainDetails89: 'The current domain name has been stopped from being resolved by the registry, and adding resolution will not take effect. If you have any questions, please contact customer service!',
        DomainList1: 'Domain name management',
        DomainList2: 'Domain name list',
        DomainList3: 'Go shopping',
        DomainList4: 'Domain name',
        DomainList5: 'Status',
        DomainList6: 'Normal',
        DomainList7: 'Due',
        DomainList8: 'Deleted',
        DomainList9: 'Time query',
        DomainList10: 'Domain name',
        DomainList11: 'Registration time',
        DomainList12: 'Expiration time',
        DomainList13: 'Status',
        DomainList14: 'Normal',
        DomainList15: 'Due',
        DomainList16: 'Deleted',
        DomainList17: 'Registration price/year',
        DomainList18: 'Operation',
        DomainList19: 'Management',
        DomainList20: 'Renewal',
        DomainList21: 'Domain name renewal',
        DomainList22: 'Domain name',
        DomainList23: 'Registration time',
        DomainList24: 'Expiration time',
        DomainList25: 'Renewal duration',
        DomainList26: 'Year',
        DomainList27: 'Payment method',
        DomainList28: 'Annual payment',
        DomainList29: 'Total price',
        DomainList30: 'Renewal',
        DomainList31: 'Domain name refund',
        DomainList32: 'Domain name',
        DomainList33: 'Registration time',
        DomainList34: 'Expiration time',
        DomainList35: 'Refund amount',
        DomainList36: 'Estimated refund amount',
        DomainList37: 'The details shall be subject to the actual financial refund',
        DomainList38: 'Refund reason',
        DomainList39: 'Refund',
        DomainList40: 'Payment succeeded',
        ServerList1: 'Physical machine management',
        ServerList2: 'Server list',
        ServerList3: 'Go shopping',
        ServerList4: 'Product name',
        ServerList5: 'Status',
        ServerList6: 'Normal',
        ServerList7: 'Expired',
        ServerList8: 'Trial',
        ServerList9: 'Time query',
        ServerList10: 'Batch renewal',
        ServerList11: 'Product name',
        ServerList12: 'Primary ip',
        ServerList13: 'Service ip',
        ServerList14: 'Copy all',
        ServerList15: 'Opening time',
        ServerList16: 'Expiration time',
        ServerList17: 'Renewal/month',
        ServerList18: 'Status',
        ServerList19: 'Normal',
        ServerList20: 'Expired',
        ServerList21: 'Refunded',
        ServerList22: 'Trial',
        ServerList23: 'Remark',
        ServerList24: 'Operation',
        ServerList25: 'Panel',
        ServerList26: 'Renewal',
        ServerList27: 'Server renewal',
        ServerList28: 'Server id',
        ServerList29: 'Primary ip',
        ServerList30: 'Server name',
        ServerList31: 'Primary ip',
        ServerList32: 'Renewal price',
        ServerList33: 'Renewal duration',
        ServerList34: 'Months',
        ServerList35: 'Payment method',
        ServerList36: 'Price',
        ServerList37: 'Modify remarks',
        ServerList38: 'Remarks',
        ServerList39: 'Please select a server first',
        ServerList40: 'Payment succeeded',
        ServerList41: 'To be activated',
        ServerList42: 'Payment amount',
        ServerList43: 'Recycled',
        ServerManager1: 'Physical machine management',
        ServerManager2: 'Server list',
        ServerManager3: 'Control panel',
        ServerManager4: 'Cancel reinstallation',
        ServerManager5: 'Control panel',
        ServerManager6: 'Order list',
        ServerManager7: 'Power on',
        ServerManager8: 'Shutdown',
        ServerManager9: 'Restart',
        ServerManager10: 'Reinstall the system',
        ServerManager11: 'Renewal',
        ServerManager12: 'Refund',
        ServerManager13: 'Server information',
        ServerManager14: 'Primary ip',
        ServerManager15: 'Service ip',
        ServerManager16: 'Copy all',
        ServerManager17: 'Business status',
        ServerManager18: 'Normal',
        ServerManager19: 'Expired',
        ServerManager20: 'Destroyed',
        ServerManager21: 'Trial',
        ServerManager22: 'User name',
        ServerManager23: 'Password',
        ServerManager24: 'Port',
        ServerManager25: 'Gateway',
        ServerManager26: 'Subnet mask',
        ServerManager27: 'Operating system',
        ServerManager28: 'Remarks',
        ServerManager29: 'Control panel',
        ServerManager30: 'Product name',
        ServerManager31: 'Opening time',
        ServerManager32: 'Expiration time',
        ServerManager33: 'Renewal price/month',
        ServerManager34: 'Renewal price/year',
        ServerManager35: 'Server number',
        ServerManager36: 'Configuration information',
        ServerManager37: 'Flow chart',
        ServerManager38: 'Last 12 hours',
        ServerManager39: 'Last 1 day',
        ServerManager40: 'Last 3 days',
        ServerManager41: 'Last 7 days',
        ServerManager42: 'Last 30 days',
        ServerManager43: 'All',
        ServerManager44: 'There is no flow chart information yet',
        ServerManager45: 'Master order',
        ServerManager46: 'Bare metal',
        ServerManager47: 'Hard disk',
        ServerManager48: 'Memory',
        ServerManager49: 'Defense',
        ServerManager50: 'Flow',
        ServerManager51: 'Bandwidth',
        ServerManager52: 'Others',
        ServerManager53: 'Newly opened',
        ServerManager54: 'Renewal',
        ServerManager55: 'Paid',
        ServerManager56: 'Unpaid',
        ServerManager57: 'Refunded ',
        ServerManager58: 'Not effective',
        ServerManager59: 'Effective',
        ServerManager60: 'Canceled',
        ServerManager61: 'Refunded',
        ServerManager62: 'Order id',
        ServerManager63: 'Order number',
        ServerManager64: 'Order type',
        ServerManager65: 'Newly opened',
        ServerManager66: 'Renewal',
        ServerManager67: 'Creation time',
        ServerManager68: 'Purchase duration',
        ServerManager69: 'Trial',
        ServerManager70: 'Month',
        ServerManager71: 'Quarter',
        ServerManager72: 'Half a year',
        ServerManager73: 'Year',
        ServerManager74: 'Purchase quantity',
        ServerManager75: 'Actual payment price',
        ServerManager76: 'Order description',
        ServerManager77: 'View details',
        ServerManager78: 'Reinstall the system',
        ServerManager79: 'Operating system',
        ServerManager80: 'Password',
        ServerManager81: 'Randomly generated',
        ServerManager82: 'Port',
        ServerManager83: 'Format system only',
        ServerManager84: 'Server renewal',
        ServerManager85: 'Server id',
        ServerManager86: 'Primary ip',
        ServerManager87: 'Server name',
        ServerManager88: 'Opening time',
        ServerManager89: 'Expiration time',
        ServerManager90: 'Renewal duration',
        ServerManager91: 'Months',
        ServerManager92: 'Payment method',
        ServerManager93: 'Price',
        ServerManager94: 'Renewal',
        ServerManager95: 'Reset password',
        ServerManager96: 'New password',
        ServerManager97: 'Randomly generated',
        ServerManager98: 'Modify remarks',
        ServerManager99: 'Remarks',
        ServerManager100: 'Server refund',
        ServerManager101: 'Server id',
        ServerManager102: 'Primary ip',
        ServerManager103: 'Server name',
        ServerManager104: 'Opening time',
        ServerManager105: 'Expiration time',
        ServerManager106: 'Refund amount',
        ServerManager107: 'Estimated refund amount',
        ServerManager108: 'The details shall be subject to the actual financial refund',
        ServerManager109: 'Refund reason',
        ServerManager110: 'Refund',
        ServerManager111: 'Operating system reinstallation progress',
        ServerManager112: 'Please select the time to query first',
        ServerManager113: 'Payment succeeded',
        ServerManager114: 'To be activated',
        ServerManager115: 'Intranet IP',
        ServerManager116: 'Logging',
        ServerManager117: 'Creation time',
        ServerManager118: 'Type',
        ServerManager119: 'Operation IP',
        ServerManager120: 'Title',
        ServerManager121: 'Details',
        ServerManager122: 'View',
        VpsList1: 'VPS management',
        VpsList2: 'VPS list',
        VpsList3: 'Go shopping',
        VpsList4: 'Product name',
        VpsList5: 'Status',
        VpsList6: 'Normal',
        VpsList7: 'Expired',
        VpsList8: 'Trial',
        VpsList9: 'Time query',
        VpsList10: 'Batch renewal',
        VpsList11: 'Product name',
        VpsList12: 'Primary ip',
        VpsList13: 'Service ip',
        VpsList14: 'Copy all',
        VpsList15: 'Opening time',
        VpsList16: 'Expiration time',
        VpsList17: 'Renewal/month',
        VpsList18: 'Status',
        VpsList19: 'Normal',
        VpsList20: 'Expired',
        VpsList21: 'Refunded',
        VpsList22: 'Trial',
        VpsList23: 'Remark',
        VpsList24: 'Operation',
        VpsList25: 'Panel',
        VpsList26: 'Renewal',
        VpsList27: 'VPS renewal',
        VpsList28: 'VPS id',
        VpsList29: 'Primary ip',
        VpsList30: 'Server name',
        VpsList31: 'Primary ip',
        VpsList32: 'Renewal price',
        VpsList33: 'Renewal duration',
        VpsList34: 'Months',
        VpsList35: 'Payment method',
        VpsList36: 'Price',
        VpsList37: 'Modify remarks',
        VpsList38: 'Remarks',
        VpsList39: 'Please select a VPS first',
        VpsList40: 'Payment succeeded',
        VpsList41: 'To be activated',
        VpsList42: 'Payment amount',
        VpsList43: 'Paused',
        VpsList44: "Close",
        VpsManager1: 'VPS Management',
        VpsManager2: 'VPS List',
        VpsManager3: 'Control Panel',
        VpsManager4: 'Console',
        VpsManager5: 'Start',
        VpsManager6: "Close",
        VpsManager7: "Restart",
        VpsManager8: 'Force Close',
        VpsManager9: 'Force Restart',
        VpsManager10: 'Renewal',
        VpsManager11: 'Refund',
        VpsManager12: 'Used Traffic',
        VpsManager13: 'Global Traffic',
        VpsManager14: 'Primary IP',
        VpsManager15: 'Reset Password',
        VpsManager16: 'Default',
        VpsManager17: 'Reinstall System',
        VpsManager18: 'Modify Notes',
        VpsManager19: 'Overview',
        VpsManager20: 'Configuration information',
        VpsManager21: 'Monitoring',
        VpsManager22: 'Bandwidth usage',
        VpsManager23: 'Memory usage',
        VpsManager24: 'CPU usage',
        VpsManager25: 'Disk usage',
        SslContacts1: 'Ssl management',
        SslContacts2: 'Ssl template',
        SslContacts3: 'Template name',
        SslContacts4: 'New template',
        SslContacts5: 'Batch delete',
        SslContacts6: 'Template name',
        SslContacts7: 'Creation time',
        SslContacts8: 'Name',
        SslContacts9: 'Mailbox',
        SslContacts10: 'Mobile phone',
        SslContacts11: 'Operation',
        SslContacts12: 'Edit',
        SslContacts13: 'Please select a template first',
        SslContactsAdd1: 'Ssl management',
        SslContactsAdd2: 'Ssl template',
        SslContactsAdd3: 'New SSL contact template',
        SslContactsAdd4: 'Fill in the form below to create a new contact information. Adding a new contact will not change the existing SSL related information.',
        SslContactsAdd5: 'Template information',
        SslContactsAdd6: 'Template name',
        SslContactsAdd7: 'Administrator information',
        SslContactsAdd8: 'First name',
        SslContactsAdd9: 'Last name',
        SslContactsAdd10: 'Mailbox',
        SslContactsAdd11: 'Mobile phone number',
        SslContactsAdd12: 'Occupation',
        SslContactsAdd13: 'Institution',
        SslContactsAdd14: 'Country/Area',
        SslContactsAdd15: 'State/Province',
        SslContactsAdd16: 'City',
        SslContactsAdd17: 'Postal code',
        SslContactsAdd18: 'Address',
        SslContactsAdd19: 'Technical support contact information',
        SslContactsAdd20: 'Same as administrator information',
        SslContactsAdd21: 'When the SSL certificate type is an enterprise organization certificate, the contact information for technical support needs to be provided.',
        SslContactsAdd22: 'Financial contact information',
        SslContactsAdd23: 'Organization contact information',
        SslContactsAdd24: 'Institution',
        SslContactsAdd25: 'Mobile phone number',
        SslContactsAdd26: 'Country/Area',
        SslContactsAdd27: 'City',
        SslContactsAdd28: 'Postal code',
        SslContactsAdd29: 'Address',
        SslContactsAdd30: 'Save template',
        SslContactsAdd31: 'Return',
        SslContactsAdd32: 'New template',
        SslContactsAdd33: 'Please fill in the template name',
        SslContactsAdd34: 'Template details',
        Ticket1: 'Work order',
        Ticket2: 'Work order list',
        Ticket3: 'Title',
        Ticket4: 'Title',
        Ticket5: 'Creation time',
        Ticket6: 'Product type',
        Ticket7: 'Status',
        Ticket8: 'Turned on',
        Ticket9: 'Processing',
        Ticket10: 'User replied',
        Ticket11: 'The engineer has replied',
        Ticket12: 'Closed',
        Ticket13: 'Deleted',
        Ticket14: 'The engineer has read',
        Ticket15: 'Unread',
        Ticket16: 'Read',
        Ticket17: 'Operation',
        Ticket18: 'View details',
        Ticket19: 'Are you sure to close the work order',
        Ticket20: 'Close work order',
        TicketAdd1: 'Work order',
        TicketAdd2: 'Submit work order',
        TicketAdd3: 'Create a new work order',
        TicketAdd4: 'Work order title',
        TicketAdd5: 'Work order type',
        TicketAdd6: 'Server',
        TicketAdd7: 'Domain name',
        TicketAdd8: 'Cloud server',
        TicketAdd9: 'Ssl certificate',
        TicketAdd10: 'Others',
        TicketAdd11: 'Service product',
        TicketAdd12: 'No data',
        TicketAdd13: 'Work order content',
        TicketAdd14: 'Submit work order',
        TicketAdd15: 'Please fill in the work order title',
        TicketAdd16: 'Please select the work order type',
        TicketAdd17: 'Please select a service product',
        TicketAdd18: 'Please fill in the work order content',
        TicketAdd19: 'Work order classification',
        TicketAdd20: 'Please fill in the work order category', 
        TicketDetails1: 'Work order',
        TicketDetails2: 'Work order list',
        TicketDetails3: 'Work order details',
        TicketDetails4: 'Title',
        TicketDetails5: 'Creation time',
        TicketDetails6: 'Product type',
        TicketDetails7: 'Product id',
        TicketDetails8: 'Work order status',
        TicketDetails9: 'Turned on',
        TicketDetails10: 'Processing',
        TicketDetails11: 'User replied',
        TicketDetails12: 'The engineer has replied',
        TicketDetails13: 'Closed',
        TicketDetails14: 'Deleted',
        TicketDetails15: 'The engineer has read',
        TicketDetails16: 'Unread',
        TicketDetails17: 'Read',
        TicketDetails18: 'Message record',
        TicketDetails19: 'User',
        TicketDetails20: 'System',
        TicketDetails21: 'Engineer',
        TicketDetails22: 'Finance',
        TicketDetails23: 'User',
        TicketDetails24: 'System',
        TicketDetails25: 'Engineer',
        TicketDetails26: 'Finance',
        TicketDetails27: 'Message reply',
        TicketDetails28: 'Reply',
        TicketDetails29: 'Please fill in the content to reply',
        TicketDetails30: 'Resource information',
        UserInfo1: 'Account management',
        UserInfo2: 'Account information',
        UserInfo3: 'Basic information',
        UserInfo4: 'Account id',
        UserInfo5: 'User name',
        UserInfo6: 'Last login ip',
        UserInfo7: 'Last login time',
        UserInfo8: 'Login information',
        UserInfo9: 'Mailbox',
        UserInfo10: 'Mobile number',
        UserInfo11: 'Password',
        UserInfo12: 'Modify',
        UserInfo13: 'Personal information',
        UserInfo14: 'Edit',
        UserInfo15: 'Save',
        UserInfo16: 'Last name',
        UserInfo17: 'First name',
        UserInfo18: 'Company name',
        UserInfo19: 'Region',
        UserInfo20: 'Country/Area',
        UserInfo21: 'State/Province',
        UserInfo22: 'City',
        UserInfo23: 'Contact address',
        UserInfo24: 'Postal code',
        UserInfo25: 'Modify password',
        UserInfo26: 'Original password',
        UserInfo27: 'New password',
        UserInfo28: 'Repeat new password',
        UserInfo29: 'Confirm the change',
        UserInfo30: 'Sensitive operation verification',
        UserInfo31: 'Google Verification',
        UserInfo32: 'Already bound',
        UserInfo33: 'Unbind',
        UserInfo34: 'Please scan the QR code to bind',
        UserInfo35: 'Dynamic verification code',
        UserInfo36: 'Binding',
        UserNotice1: 'Notification settings',
        UserNotice2: 'Telegram notification',
        UserNotice3: "If you don't know what your telegram ID is, you can first pay attention to our official robot",
        UserNotice4: 'Send a command to the robot: get the ID, and he will return your ID to you',
        UserNotice5: 'Email system notification',
        UserNotice6: 'Save changes',
        UserNotice7: 'Please enter the telegraph ID first',
        UserNotice8: 'Price display notification',
        UserLoginLog1: 'Account management',
        UserLoginLog2: 'Login log',
        UserLoginLog3: 'Ip address',
        UserLoginLog4: 'Status',
        UserLoginLog5: 'Success',
        UserLoginLog6: 'Failed',
        UserLoginLog7: 'Time query',
        UserLoginLog8: 'Operation information',
        UserLoginLog9: 'Operation time',
        UserLoginLog10: 'Ip address',
        UserLoginLog11: 'Status',
        UserLoginLog12: 'Success',
        UserLoginLog13: 'Failed',
        UserCoupons1: 'Account Management',
        UserCoupons2: 'Coupon List',
        UserCoupons3: 'Name',
        UserCoupons4: 'Consumption Threshold',
        UserCoupons5: 'Coupon Amount',
        UserCoupons6: 'Discount',
        UserCoupons7: 'Validity Days',
        UserCoupons8: 'Type',
        UserCoupons9: 'Reduction Coupon',
        UserCoupons10: 'Discount Coupon',
        UserCoupons11: 'Voucher',
        UserCoupons12: 'Status',
        UserCoupons13: 'Unused',
        UserCoupons14: 'Used',
        UserCoupons15: 'Usage scenario',
        UserCoupons16: 'General',
        UserCoupons17: 'Physical machine',
        UserCoupons18: 'Cloud server',
        UserCoupons19: 'Domain name',
        UserCoupons20: 'Expiration time',
        UserCoupons21: 'Is it expired',
        UserCoupons22: 'Expired',
        UserCoupons23: 'Not expired',
        UserCoupons24: 'Receipt time',
        BalanceBill1: 'Order management',
        BalanceBill2: 'Order list',
        BalanceBill3: 'Order number',
        BalanceBill4: 'Creation time',
        BalanceBill5: 'Payment order number',
        BalanceBill6: 'Creation time',
        BalanceBill7: 'Order amount',
        BalanceBill8: 'Actual payment amount',
        BalanceBill9: 'Payment method',
        BalanceBill10: 'Payment status',
        BalanceBill11: 'Payment succeeded',
        BalanceBill12: 'Unpaid',
        BalanceBill13: 'Refunded',
        BalanceBill14: 'Operation',
        BalanceBill15: 'Partial refund',
        BalanceBill16: 'Transaction expired',
        BalanceBillDetails1: 'User center',
        BalanceBillDetails2: 'Order management',
        BalanceBillDetails3: 'Order list',
        BalanceBillDetails4: 'Order details',
        BalanceBillDetails5: 'Order number',
        BalanceBillDetails6: 'Print',
        BalanceBillDetails7: 'Download',
        BalanceBillDetails8: 'Order type',
        BalanceBillDetails9: 'Creation time',
        BalanceBillDetails10: 'Unpaid',
        BalanceBillDetails11: 'Payment succeeded',
        BalanceBillDetails12: 'Refunded',
        BalanceBillDetails13: 'Paid to',
        BalanceBillDetails14: 'Invoice to',
        BalanceBillDetails15: 'Billing item',
        BalanceBillDetails16: 'Description',
        BalanceBillDetails17: 'Order Status',
        BalanceBillDetails18: 'Manage',
        BalanceBillDetails19: 'Amount',
        BalanceBillDetails20: 'Paid',
        BalanceBillDetails21: 'Unpaid',
        BalanceBillDetails22: 'Refunded',
        BalanceBillDetails23: 'Initiate payment amount',
        BalanceBillDetails24: 'Amount paid',
        BalanceBillDetails25: 'Bill amount',
        BalanceBillDetails26: 'Refund amount',
        BalanceBillDetails27: 'Payment method',
        BalanceBillDetails28: 'Pay now',
        BalanceBillDetails29: 'Payment method',
        BalanceBillDetails30: 'Payment succeeded',
        BalanceBillDetails31: 'Physical server',
        BalanceBillDetails32: 'Cloud server',
        BalancebillDetails33: 'Ssl certificate',
        BalanceBillDetails34: 'Domain name',
        BalanceBillDetails35: 'Balance recharge',
        BalanceBillDetails36: 'Recharge succeeded',
        BalanceBillDetails37: 'Unpaid',
        BalanceBillDetails38: 'Not received',
        BalanceBillDetails39: 'Unpaid credit amount',
        BalanceBillDetails40: 'Payment failed',
        BalanceBillDetails41: 'Coupon deduction',
        SslList1: 'Ssl management',
        SslList2: 'Ssl list',
        SslList3: 'Go shopping',
        SslList4: 'Product name',
        SslList5: 'Domain name',
        SslList6: 'Certificate number/ca/instance number',
        SslList7: 'Payment order number',
        SslList8: 'Time query',
        SslList9: 'Resolve host',
        SslList10: 'Parsing method',
        SslList11: 'Parse value',
        SslList12: 'Product name',
        SslList13: 'Primary domain name',
        SslList14: 'Ca order no',
        SslList15: 'Instance number',
        SslList16: 'Purchase time',
        SslList17: 'Status',
        SslList18: 'Canceled',
        SslList19: 'Application succeeded',
        SslList20: 'Applying',
        SslList21: 'Expired',
        SslList22: 'Re signed',
        SslList23: 'Application failed',
        SslList24: 'Renewed',
        SslList25: 'Revoked',
        SslList26: 'Refund',
        SslList27: 'To be submitted',
        SslList28: 'Issuing status',
        SslList29: 'Incomplete',
        SslList30: 'Completed',
        SslList31: 'Validation in progress',
        SslList32: 'Validation status',
        SslList33: 'Incomplete',
        SslList34: 'Completed',
        SslList35: 'Validation in progress',
        SslList36: 'Operation',
        SslList37: 'Management',
        SslList38: 'Domain name validation',
        SslList39: 'Ssl certificate information',
        SslList40: 'Channel',
        SslList41: 'Certificate brand',
        SslList42: 'Certificate type',
        SslList43: 'Domain name type',
        SslList44: 'Single domain name',
        SslList45: 'Multi domain name',
        SslList46: 'Wildcard',
        SslList47: 'Number of domain names',
        SslList48: 'Single domain name verification',
        SslList49: 'Multi domain name verification',
        SslList50: 'Please fill in the main domain name without the * sign. For example, example.com covers all *.example.com domain names, and a.example.com covers all *.a.example.com domain names.',
        SslList51: 'Wildcard validation',
        SslList52: 'Domain name',
        SslList53: 'Validation rule',
        SslList54: 'Add domain name',
        SslList55: 'Contact information',
        SslList56: 'New template',
        SslList57: 'The information template has not been created yet',
        SslList58: 'Name',
        SslList59: 'Mailbox',
        SslList60: 'Mobile phone',
        SslList61: 'Submit application',
        SslList62: 'Dns authentication',
        SslList63: 'Http file validation',
        SslList64: 'Https file validation',
        SslList65: 'Mailbox validation',
        SslList66: 'Please fill in the domain name information and verification rules first',
    },
}

export default language